SJ.on.preload(() => {
	SJ.LoadingWindow = class extends SJ.UI.Element {
		constructor(afterLoad = () => { }) {
			super(0, 0);

			this.position = 'absolute';
			this.zIndex = 9999;

			const background = new SJ.DrawableRect(
				0,
				0,
				SJ.SCREEN_WIDTH,
				SJ.SCREEN_HEIGHT,
				color(0, 0, 0)
			);
			this.addChild(background);

			const backgroundImage = new SJ.Texture(SJ.loadingScreenImage, 0, 0);
			this.addChild(backgroundImage);

			const loadingLabel = new SJ.Label(
				'Ładowanie',
				SJ.SCREEN_MIDDLE_X,
				SJ.SCREEN_MIDDLE_Y + 100,
				CENTER,
				CENTER,
				42
			);
			this.addChild(loadingLabel);

			this.progressBarTargetLength = 400;

			const progressBarX = SJ.SCREEN_MIDDLE_X - 200;
			const progressBarY = SJ.SCREEN_MIDDLE_Y + 140;
			const progressBarHeight = 20;

			this.progressBarBackground = new SJ.DrawableRect(
				progressBarX,
				progressBarY,
				this.progressBarTargetLength - 1,
				progressBarHeight,
				color(100)
			);
			this.addChild(this.progressBarBackground);

			this.progressBar = new SJ.DrawableRect(
				progressBarX,
				progressBarY,
				0,
				progressBarHeight,
				color(255)
			);
			this.addChild(this.progressBar);

			this.afterLoad = afterLoad;
			this.afterLoadDone = false;
		}

		getLoadedPercent() {
			const percent =
				SJ.ImageLoader.remainingToLoad === 0
					? 100
					: 100 -
					(SJ.ImageLoader.remainingToLoad * 100) / SJ.ImageLoader.totalToLoad;

			return percent / 100;
		}

		updateProgressBar() {
			let lerpSens = 0.8;

			let lerpValue = lerp(
				this.progressBar.w,
				this.getLoadedPercent() * this.progressBarTargetLength,
				lerpSens
			);

			if (lerpValue >= this.progressBar.w) this.progressBar.w = lerpValue;

			if (!this.progressBar.w || this.getLoadedPercent() <= 0)
				this.progressBar.w = 0;
		}

		_draw() {
			this.updateProgressBar();

			if (this.progressBar.w < this.progressBarTargetLength) {
				SJ.mouseMoveEnable = false;
				SJ.mouseScreenX = 0;
				SJ.mouseScreenY = 0;

				push();

				translate(this.x, this.y);

				this.draw();
				this.forEachChild((child) => {
					child._draw();
				});

				pop();

				this.afterLoadDone = false;
			} else if (!this.afterLoadDone) {
				this.afterLoad();

				console.log('Screen loaded', SJ.imagesLoaded);
				SJ.imagesLoaded = 0;

				SJ.mouseMoveEnable = true;
				this.afterLoadDone = true;
			}
		}
	};

	SJ.WindDisplay = class extends SJ.UI.Element {
		constructor() {
			super(SJ.SCREEN_WIDTH - 150, 100);

			const gameSS = SJ.viewsSpriteSheets.gameSS;

			this.backgroundImage = new SJ.SpriteSheetTexture2(
				gameSS,
				0,
				0,
				null,
				null,
				665,
				54,
				141,
				178
			);
		}

		draw() {
			const gameSS = SJ.viewsSpriteSheets.gameSS;

			this.backgroundImage.draw();

			push();
			translate(70, 70);
			rotate(SJ.airSystem.angle);
			image(gameSS, -45, -45, 90, 90, 576, 55, 88, 88);
			pop();

			const airForce = SJ.airSystem.airForce;
			const decVal = floor((airForce * 10) % 10);
			const roundedForce = floor(airForce);

			fill(255);
			textSize(16);
			text(roundedForce + '.' + decVal + ' m/s', 55, 132);
		}
	};

	SJ.SpeedDisplay = class extends SJ.UI.Element {
		constructor() {
			super();
			this.disp = new SJ.Label(
				'Szybkość',
				SJ.SCREEN_WIDTH - 70,
				258,
				CENTER,
				CENTER,
				16
			);
			this.addChild(this.disp);
		}

		draw() {
			const jumperVel = SJ.jumper.body.velocity;
			const velMagn = Matter.Vector.magnitude(jumperVel) * 4.8;
			SJ.jumperSpeed = floor(velMagn * 10.0) / 10.0;

			if (SJ.jumperSpeed > SJ.higherJumperSpeed) {
				SJ.higherJumperSpeed = SJ.jumperSpeed;
			}

			this.disp.content = SJ.jumperSpeed + ' km/h';
		}
	};

	SJ.HeightDisplay = class extends SJ.UI.Element {
		constructor() {
			super();
		}

		draw() {
			let jumperHeight = 0;

			if (SJ.jumper.state == SJ.jumper.S.FLYING) {
				const jumperX = SJ.jumper.body.position.x;

				for (let i = 1; i < SJ.V.padCollisionPoints.length; i++) {
					const p2 = SJ.V.padCollisionPoints[i];

					if (jumperX <= p2.x) {
						const p1 = SJ.V.padCollisionPoints[i - 1];
						const diffX = jumperX - p1.x;
						const distX = p2.x - p1.x;
						const diffY = p2.y - p1.y;
						const k = diffX / distX;
						const yUnderJumper = p1.y + k * diffY;

						const heightInPixels = yUnderJumper - SJ.jumper.body.position.y;
						const heightInMeters = heightInPixels * SJ.V.PIXELS_TO_METERS;

						if (heightInMeters > SJ.higherJumperHeight) {
							SJ.higherJumperHeight = heightInMeters;
						}

						jumperHeight = max(floor(heightInMeters * 10) / 10, 0);
						break;
					}
				}
			}

			if (jumperHeight <= SJ.V.maxLandingHeight) SJ.jumper.canLand = true;
			else SJ.jumper.canLand = false;

			SJ.scoreCounter.jumperHeight = jumperHeight;
		}
	};

	SJ.ItemsDisplay = class extends SJ.UI.Element {
		constructor() {
			super(22, 210);
		}

		createItemButtons() {
			this.itemsLayout = new SJ.Layout(0, 0, [], 20, 'column');
			this.itemsLayout.verticalAlign = TOP;
			this.addChild(this.itemsLayout);

			SJ.itemsManager._items.forEach((item) => {
				const itemBtn = new SJ.ItemButton(item);
				this.itemsLayout.addChild(itemBtn);
			});
		}

		resetItemButtons() {
			this.children = [];
			this.createItemButtons();
		}

		updateItemButtons() {
			this.itemsLayout.children.forEach((itemButton) => {
				const newItem = SJ.itemsManager._items.filter((e) => {
					return e.id === itemButton.item.id;
				})[0];
				itemButton.update(newItem);
			});
		}
	};

	SJ.ItemButton = class extends SJ.TextureButton {
		constructor(item) {
			const itemSpritesData = {
				bindings: {
					mainTexture: { x: 1198, y: 75, w: 95, h: 76 },
					goodRunOfLuck: { x: 927, y: 306, w: 309, h: 142 },
					megaRunOfLuck: { x: 1029, y: 461, w: 343, h: 155 },
				},
				boots: {
					mainTexture: { x: 820, y: 75, w: 95, h: 75 },
					goodRunOfLuck: { x: 618, y: 306, w: 309, h: 142 },
					megaRunOfLuck: { x: 686, y: 461, w: 343, h: 155 },
				},
				gloves: {
					mainTexture: { x: 915, y: 75, w: 95, h: 76 },
					goodRunOfLuck: { x: 916, y: 164, w: 309, h: 142 },
					megaRunOfLuck: { x: 1236, y: 306, w: 343, h: 155 },
				},
				goggles: {
					mainTexture: { x: 630, y: 75, w: 95, h: 75 },
					goodRunOfLuck: { x: 1225, y: 164, w: 309, h: 142 },
					megaRunOfLuck: { x: 1372, y: 461, w: 343, h: 156 },
				},
				helmet: {
					mainTexture: { x: 725, y: 75, w: 95, h: 75 },
					goodRunOfLuck: { x: 1534, y: 164, w: 309, h: 142 },
					megaRunOfLuck: { x: 1579, y: 306, w: 343, h: 155 },
				},
				skis: {
					mainTexture: { x: 1010, y: 75, w: 93, h: 76 },
					goodRunOfLuck: { x: 0, y: 306, w: 309, h: 142 },
					megaRunOfLuck: { x: 0, y: 461, w: 343, h: 155 },
				},
				suit: {
					mainTexture: { x: 1103, y: 75, w: 95, h: 76 },
					goodRunOfLuck: { x: 309, y: 306, w: 309, h: 142 },
					megaRunOfLuck: { x: 343, y: 461, w: 343, h: 155 },
				},
			};

			const gameSS2 = SJ.viewsSpriteSheets.gameSS2;

			super(
				0,
				0,
				null,
				new SJ.SpriteSheetTexture2(
					gameSS2,
					0,
					0,
					null,
					null,
					itemSpritesData[item.id].mainTexture.x,
					itemSpritesData[item.id].mainTexture.y,
					itemSpritesData[item.id].mainTexture.w,
					itemSpritesData[item.id].mainTexture.h
				)
			);

			this.item = item;

			this.increment = `${this.item.increment ? '+' : '-'}`;
			this.varMultLabelColor = color(255);

			this.varMultLabel = new SJ.Label(
				`${this.increment}${this.item.varMult}%`,
				85,
				62,
				RIGHT,
				CENTER,
				15,
				this.varMultLabelColor,
				null,
				color(0),
				2
			);
			this.addChild(this.varMultLabel);

			this.noRunOfLuckInfo = new SJ.SpeechBubble(
				'Nie posiadasz Passy dla tego sprzętu\nPo zakupie aktywujesz ją kliknięciem'
			);
			this.noRunOfLuckInfo.x = 220;
			this.noRunOfLuckInfo.y = 0;
			this.noRunOfLuckInfo.label.fontSize = 17;
			this.addChild(this.noRunOfLuckInfo);

			if (this.item.runOfLuckLevel !== 0) {
				this.noRunOfLuckInfo.hide();

				let runOfLuckImageName = '';

				let runOfLuckPointsLabelPosition = { x: 220, y: 120 };
				let runOfLuckVarMultLabelPosition = { x: 285, y: 87 };
				let runOfLuckVarMultLabelAligment = RIGHT;

				if (this.item.runOfLuckLevel === 6) {
					runOfLuckImageName = 'megaRunOfLuck';

					runOfLuckPointsLabelPosition = { x: 130, y: 134 };
					runOfLuckVarMultLabelPosition = { x: -7, y: 95 };
					runOfLuckVarMultLabelAligment = LEFT;

					this.varMultLabelColor = color(255, 0, 0);
				} else if (this.item.runOfLuckLevel === 3) {
					runOfLuckImageName = 'goodRunOfLuck';
					this.varMultLabelColor = color(0, 255, 0);
				}

				this.runOfLuckBtn = new SJ.TextureButton(
					130,
					-50,
					null,
					new SJ.SpriteSheetTexture2(
						gameSS2,
						0,
						0,
						null,
						null,
						itemSpritesData[this.item.id][runOfLuckImageName].x,
						itemSpritesData[this.item.id][runOfLuckImageName].y,
						itemSpritesData[this.item.id][runOfLuckImageName].w,
						itemSpritesData[this.item.id][runOfLuckImageName].h
					)
				);
				this.runOfLuckBtn.hide();

				this.runOfLuckPointsLabel = new SJ.Label(
					this.item.runOfLuckPoints,
					runOfLuckPointsLabelPosition.x,
					runOfLuckPointsLabelPosition.y,
					LEFT,
					CENTER,
					16
				);

				this.runOfLuckVarMultLabel = new SJ.Label(
					`${this.increment}${this.item.getVarMult(
						this.item.level + this.item.runOfLuckLevel
					)}%`,
					runOfLuckVarMultLabelPosition.x,
					runOfLuckVarMultLabelPosition.y,
					runOfLuckVarMultLabelAligment,
					CENTER,
					20,
					color(0, 255, 0),
					null,
					color(0),
					2
				);
				this.runOfLuckVarMultLabel.workingName = `${this.item.id}`;

				this.runOfLuckBtn.addChild(this.runOfLuckPointsLabel);
				this.runOfLuckBtn.addChild(this.runOfLuckVarMultLabel);

				this.addChild(this.runOfLuckBtn);
			}

			this.runOfLuckActiveTexture = new SJ.SpriteSheetTexture2(
				gameSS2,
				-12,
				-12,
				null,
				null,
				524,
				164,
				113,
				93
			);
			this.addChild(this.runOfLuckActiveTexture);

			this.update(this.item);
		}

		update(item) {
			this.item = item;

			this.varMultLabel.content = `${this.increment}${this.item.varMult}%`;

			if (this.item.runOfLuckLevel !== 0) {
				this.runOfLuckPointsLabel.content = this.item.runOfLuckPoints;
			}

			if (this.item.isRunOfLuckActive) {
				this.varMultLabel.fontColor = this.varMultLabelColor;
				this.runOfLuckActiveTexture.show();
			} else {
				this.runOfLuckActiveTexture.hide();
				this.varMultLabel.fontColor = color(255);
			}
		}

		onMouseEnter = () => {
			if (this.runOfLuckBtn) this.runOfLuckBtn.show();
			else this.noRunOfLuckInfo.show();
		};

		onMouseLeave = () => {
			if (this.runOfLuckBtn) this.runOfLuckBtn.hide();
			else this.noRunOfLuckInfo.hide();
		};

		onMousePress = () => {
			if (this.runOfLuckBtn) {
				if (!this.item.isRunOfLuckActive) {
					this.item.activateRunOfLuck();
				}
			}
		};
	};

	SJ.UserDataBar = class extends SJ.DrawableRect {
		constructor() {
			super(0, 0, 0, 0, color(0, 0, 0, 0));

			this.fontSize = 20;
			this.imageSize = 60;

			this.isVisible = true;

			const userDataBarSS = SJ.userDataBarSS;

			this.background = new SJ.SpriteSheetTexture(
				userDataBarSS,
				0,
				0,
				null,
				null,
				0,
				74,
				1600,
				131
			);
			this.addChild(this.background);

			this.barLayout = new SJ.Layout(
				SJ.SCREEN_MIDDLE_X,
				45,
				[],
				null,
				'row',
				CENTER,
				true,
				SJ.SCREEN_WIDTH - 200,
				80
			);
			this.addChild(this.barLayout);

			//--------------------------------

			this.userName = new SJ.Label(
				SJ.playerData.data['name'],
				100,
				40,
				LEFT,
				CENTER,
				this.fontSize,
				color(255, 255, 255),
				NORMAL,
				color(80),
				3
			);

			this.userName.onMousePress = () => {
				if (!window.sessionStorage.getItem('playername')) {
					SJ.registration.show();
				}
			};

			this.userName.mouseMode = SJ.UI.MOUSE_MODE.TEST_AND_BLOCK;

			this.barLayout.addChild(this.userName);

			//--------------------------------

			const jumpsCountLayout = new SJ.Layout(0, 0, [], 5);

			this.jumpsCountImage = new SJ.SpriteSheetTexture(
				userDataBarSS,
				0,
				0,
				null,
				null,
				175,
				0,
				64,
				59
			);
			this.jumpsCountImage.mouseMode = SJ.UI.MOUSE_MODE.TEST_AND_BLOCK;

			this.jumpsCountSpeechBubble = new SJ.SpeechBubble(
				'Ilość pozostałych skoków \n rankingowych na dzisiaj'
			);

			this.jumpsCountImage.addChild(this.jumpsCountSpeechBubble);

			this.jumpsCountImage.onMouseEnter = () =>
				this.jumpsCountSpeechBubble.show();
			this.jumpsCountImage.onMouseLeave = () =>
				this.jumpsCountSpeechBubble.hide();

			jumpsCountLayout.addChild(this.jumpsCountImage);

			let worldCupDailyJumpsCount =
				SJ.V.maxDailyJumpsCount - SJ.playerData.data['worldcupDailyJumpsCount'];
			let tournamentDailyJumpsCount =
				SJ.V.maxDailyJumpsCount -
				SJ.playerData.data['tournamentDailyJumpsCount'];

			let jumpsCountColor = color(255, 255, 255);

			if (worldCupDailyJumpsCount <= 0) {
				jumpsCountColor = color(255, 0, 0);
				worldCupDailyJumpsCount = 0;
			}

			this.worldCupDailyJumpsCountLabel = new SJ.Label(
				`${worldCupDailyJumpsCount}`,
				0,
				0,
				LEFT,
				CENTER,
				this.fontSize,
				jumpsCountColor,
				NORMAL,
				color(80),
				3
			);

			jumpsCountLayout.addChild(this.worldCupDailyJumpsCountLabel);

			this.slash = new SJ.Label(
				`/`,
				0,
				0,
				LEFT,
				CENTER,
				this.fontSize,
				color(255, 255, 255),
				NORMAL,
				color(80),
				3
			);
			jumpsCountLayout.addChild(this.slash);

			jumpsCountColor = color(255, 255, 255);

			if (tournamentDailyJumpsCount <= 0) {
				jumpsCountColor = color(255, 0, 0);
				tournamentDailyJumpsCount = 0;
			}

			this.tournamentDailyJumpsCountLabel = new SJ.Label(
				`${tournamentDailyJumpsCount}`,
				0,
				0,
				LEFT,
				CENTER,
				this.fontSize,
				jumpsCountColor,
				NORMAL,
				color(80),
				3
			);
			jumpsCountLayout.addChild(this.tournamentDailyJumpsCountLabel);

			this.barLayout.addChild(jumpsCountLayout);

			//--------------------------------

			const worldCupLayout = new SJ.Layout(0, 0, [], 5);

			this.worldCupScoreImage = new SJ.SpriteSheetTexture(
				userDataBarSS,
				0,
				0,
				null,
				null,
				56,
				0,
				56,
				60
			);
			this.worldCupScoreImage.mouseMode = SJ.UI.MOUSE_MODE.TEST_AND_BLOCK;

			this.worldCupScoreSpeechBubble = new SJ.SpeechBubble(
				'Pozycja i punkty w Rankingu \n Pucharu Świata'
			);
			this.worldCupScoreImage.addChild(this.worldCupScoreSpeechBubble);

			this.worldCupScoreImage.onMouseEnter = () => {
				this.worldCupScoreSpeechBubble.show();
			};

			this.worldCupScoreImage.onMouseLeave = () => {
				this.worldCupScoreSpeechBubble.hide();
			};

			worldCupLayout.addChild(this.worldCupScoreImage);

			this.worldCupScore = new SJ.Label(
				`${SJ.playerData.data['mapGlobalRankingPosition']}. \n${SJ.playerData.data['mapGlobalRankingScore']}`,
				500,
				40,
				LEFT,
				CENTER,
				this.fontSize,
				color(255, 255, 255),
				NORMAL,
				color(80),
				3
			);

			worldCupLayout.addChild(this.worldCupScore);

			this.barLayout.addChild(worldCupLayout);

			//--------------------------------

			const tournamentLayout = new SJ.Layout(0, 0, [], 5);

			this.tournamentScoreImage = new SJ.SpriteSheetTexture(
				userDataBarSS,
				0,
				0,
				null,
				null,
				112,
				0,
				63,
				60
			);
			this.tournamentScoreImage.mouseMode = SJ.UI.MOUSE_MODE.TEST_AND_BLOCK;

			this.tournamentScoreSpeechBubble = new SJ.SpeechBubble(
				'Pozycja i punkty w Rankingu \n Turniejowym'
			);
			this.tournamentScoreImage.addChild(this.tournamentScoreSpeechBubble);

			this.tournamentScoreImage.onMouseEnter = () => {
				this.tournamentScoreSpeechBubble.show();
			};

			this.tournamentScoreImage.onMouseLeave = () => {
				this.tournamentScoreSpeechBubble.hide();
			};

			tournamentLayout.addChild(this.tournamentScoreImage);

			this.tournamentScore = new SJ.Label(
				`${SJ.playerData.data['tournamentRankingPosition']}. \n${SJ.playerData.data['tournamentRankingScore']}`,
				0,
				0,
				LEFT,
				CENTER,
				this.fontSize,
				color(255, 255, 255),
				NORMAL,
				color(80),
				3
			);
			// this.addChild(this.tournamentScore);
			tournamentLayout.addChild(this.tournamentScore);

			this.barLayout.addChild(tournamentLayout);

			//--------------------------------

			const rankLayout = new SJ.Layout(0, 0, [], 5);

			this.rankImagesData = {
				Junior: { x: 449, y: 0, w: 75, h: 74 },
				Kadrowicz: { x: 239, y: 0, w: 70, h: 60 },
				Klubowicz: { x: 524, y: 0, w: 76, h: 60 },
				'Legenda Skoków': { x: 600, y: 0, w: 76, h: 66 },
				'Medalista Olimpijski': { x: 676, y: 0, w: 76, h: 60 },
				Medalista: { x: 309, y: 0, w: 70, h: 60 },
				'Mistrz Kraju': { x: 379, y: 0, w: 70, h: 60 },
				'Mistrz Świata': { x: 752, y: 0, w: 76, h: 60 },
				Młodzik: { x: 828, y: 0, w: 76, h: 60 },
				Olimpijczyk: { x: 904, y: 0, w: 76, h: 60 },
				Zawodowiec: { x: 980, y: 0, w: 76, h: 60 },
			};

			// console.log(SJ.playerData.data['mapGlobalRankingRank']);

			this.rankImage = new SJ.SpriteSheetTexture2(
				userDataBarSS,
				0,
				0,
				null,
				null,
				this.rankImagesData[SJ.playerData.data['mapGlobalRankingRank']].x,
				this.rankImagesData[SJ.playerData.data['mapGlobalRankingRank']].y,
				this.rankImagesData[SJ.playerData.data['mapGlobalRankingRank']].w,
				this.rankImagesData[SJ.playerData.data['mapGlobalRankingRank']].h
			);

			this.rankImage.mouseMode = SJ.UI.MOUSE_MODE.TEST_AND_BLOCK;

			this.rankSpeechBubble = new SJ.SpeechBubble('Twój aktualny Tytuł');
			this.rankImage.addChild(this.rankSpeechBubble);

			this.rankImage.onMouseEnter = () => {
				this.rankSpeechBubble.show();
			};

			this.rankImage.onMouseLeave = () => {
				this.rankSpeechBubble.hide();
			};

			rankLayout.addChild(this.rankImage);

			this.rank = new SJ.Label(
				`${SJ.playerData.data['mapGlobalRankingRank']}`,
				1000,
				40,
				LEFT,
				CENTER,
				this.fontSize,
				color(255, 255, 255),
				NORMAL,
				color(80),
				3
			);
			rankLayout.addChild(this.rank);

			this.barLayout.addChild(rankLayout);

			//--------------------------------

			const moneyLayout = new SJ.Layout(0, 0, [], 5);

			this.moneyImage = new SJ.SpriteSheetTexture(
				userDataBarSS,
				0,
				0,
				null,
				null,
				0,
				0,
				56,
				60
			);

			this.moneyImage.mouseMode = SJ.UI.MOUSE_MODE.TEST_AND_BLOCK;

			this.moneySpeechBubble = new SJ.SpeechBubble('Twój aktualny Stan Konta');
			this.moneyImage.addChild(this.moneySpeechBubble);

			this.moneyImage.onMouseEnter = () => {
				this.moneySpeechBubble.show();
			};

			this.moneyImage.onMouseLeave = () => {
				this.moneySpeechBubble.hide();
			};

			moneyLayout.addChild(this.moneyImage);

			this.money = new SJ.Label(
				`${SJ.playerData.data['money']} €`,
				1200,
				40,
				LEFT,
				CENTER,
				this.fontSize,
				color(255, 255, 255),
				NORMAL,
				color(80),
				3
			);
			// this.addChild(this.money);
			moneyLayout.addChild(this.money);

			this.barLayout.addChild(moneyLayout);

			//--------------------------------

			const vipMoneyLayout = new SJ.Layout(0, 0, [], 5);

			this.vipMoneyImage = new SJ.SpriteSheetTexture(
				userDataBarSS,
				0,
				0,
				null,
				null,
				1056,
				0,
				76,
				60
			);

			this.vipMoneyImage.mouseMode = SJ.UI.MOUSE_MODE.TEST_AND_BLOCK;

			this.vipMoneySpeechBubble = new SJ.SpeechBubble('Ilość Monet VIP');
			this.vipMoneyImage.addChild(this.vipMoneySpeechBubble);

			this.vipMoneyImage.onMouseEnter = () => {
				this.vipMoneySpeechBubble.show();
			};

			this.vipMoneyImage.onMouseLeave = () => {
				this.vipMoneySpeechBubble.hide();
			};

			vipMoneyLayout.addChild(this.vipMoneyImage);

			this.vipMoney = new SJ.Label(
				`${SJ.playerData.data['VIPmoney']} VIP`,
				1200,
				40,
				LEFT,
				CENTER,
				this.fontSize,
				color(255, 255, 255),
				NORMAL,
				color(80),
				3
			);
			vipMoneyLayout.addChild(this.vipMoney);

			this.barLayout.addChild(vipMoneyLayout);

			this.vipAccountImage = new SJ.SpriteSheetTexture2(
				userDataBarSS,
				0,
				0,
				null,
				null,
				1132,
				0,
				82,
				60
			);
			this.vipAccountImage.mouseMode = SJ.UI.MOUSE_MODE.TEST_AND_BLOCK;

			this.vipAccountImageSpeechBubble = new SJ.SpeechBubble(
				`Masz Konto VIP ważne do: \n ${SJ.playerData.getVipAccountExpirationDate()}`
			);
			this.vipAccountImage.addChild(this.vipAccountImageSpeechBubble);

			this.vipAccountImage.onMouseEnter = () => {
				this.vipAccountImageSpeechBubble.show();
			};

			this.vipAccountImage.onMouseLeave = () => {
				this.vipAccountImageSpeechBubble.hide();
			};

			this.vipAccountImage.hide();

			this.barLayout.addChild(this.vipAccountImage);

			//--------------------------------

			const timestamp = round(Date.now() / 1000);

			if (timestamp < SJ.playerData.data['vipAccountExpirationTime']) {
				this.userName.fontColor = color(242, 188, 43);
				this.vipAccountImage.show();
			}
		}

		onScreenChange() {
			this.updateDisplayData();
		}

		updateDisplayData() {
			const userDataBarSS = SJ.userDataBarSS;

			SJ.playerData.updatePlayerRankPosition();

			let worldCupDailyJumpsCount =
				SJ.V.maxDailyJumpsCount - SJ.playerData.data['worldcupDailyJumpsCount'];
			let tournamentDailyJumpsCount =
				SJ.V.maxDailyJumpsCount -
				SJ.playerData.data['tournamentDailyJumpsCount'];

			this.worldCupDailyJumpsCountLabel.fontColor = color(255);
			this.tournamentDailyJumpsCountLabel.fontColor = color(255);

			if (worldCupDailyJumpsCount <= 0) {
				this.worldCupDailyJumpsCountLabel.fontColor = color(255, 0, 0);
				worldCupDailyJumpsCount = 0;
			}

			this.worldCupDailyJumpsCountLabel.content = `${worldCupDailyJumpsCount}`;

			if (tournamentDailyJumpsCount <= 0) {
				this.tournamentDailyJumpsCountLabel.fontColor = color(255, 0, 0);
				tournamentDailyJumpsCount = 0;
			}

			this.tournamentDailyJumpsCountLabel.content = `${tournamentDailyJumpsCount}`;

			this.worldCupScore.content = `${SJ.playerData.data['mapGlobalRankingPosition']
				}. \n${SJ.playerData.data['mapGlobalRankingScore'].toFixed(1)}`;

			this.tournamentScore.content = `${SJ.playerData.data['tournamentRankingPosition']
				}. \n${SJ.playerData.data['tournamentRankingScore'].toFixed(1)}`;

			this.rankImage = new SJ.SpriteSheetTexture2(
				userDataBarSS,
				0,
				0,
				null,
				null,
				this.rankImagesData[SJ.playerData.data['mapGlobalRankingRank']].x,
				this.rankImagesData[SJ.playerData.data['mapGlobalRankingRank']].y,
				this.rankImagesData[SJ.playerData.data['mapGlobalRankingRank']].w,
				this.rankImagesData[SJ.playerData.data['mapGlobalRankingRank']].h
			);

			this.rank.content = `${SJ.playerData.data['mapGlobalRankingRank']}`;

			this.money.content = `${SJ.playerData.data['money']} €`;

			this.vipMoney.content = `${SJ.playerData.data['VIPmoney']} VIP`;

			const timestamp = round(Date.now() / 1000);

			if (timestamp < SJ.playerData.data['vipAccountExpirationTime']) {
				this.userName.fontColor = color(242, 188, 43);

				this.vipAccountImageSpeechBubble.label.content = `Masz Konto VIP ważne do: \n ${SJ.playerData.getVipAccountExpirationDate()}`;

				this.vipAccountImage.show();
			} else {
				this.vipAccountImage.hide();
			}
		}
	};

	const bgImagePreload = SJ.ImageLoader.load('UI/speech-bubble-long.png');

	SJ.SpeechBubble = class extends SJ.UI.Element {
		constructor(label, x = 0, y = 60) {
			super(x, y);

			this.hide();

			this.label = new SJ.Label(
				label,
				0,
				0,
				CENTER,
				CENTER,
				20,
				color(255),
				NORMAL,
				color(81),
				2
			);

			this.backgroundImage = new SJ.SpriteSheetTexture2(
				bgImagePreload,
				0,
				0,
				null,
				null,
				0,
				0,
				378,
				97,
				null,
				null,
				() => {
					this.label.x = 378 / 2;
					this.label.y = 97 / 2;

					this.label.w = 378 - 20;

					this.x -= 378 / 2.5;
				}
			);

			this.addChild(this.backgroundImage);
			this.addChild(this.label);
		}
	};

	SJ.PauseMenu = class extends SJ.UI.Element {
		constructor() {
			super(20, 120);

			const gameSS = SJ.viewsSpriteSheets.gameSS;

			const menuTexture = new SJ.SpriteSheetTexture2(
				gameSS,
				100,
				0,
				null,
				null,
				1379,
				0,
				508,
				54
			);
			menuTexture.hide();
			this.addChild(menuTexture);

			const x = 100;
			const w = 180;
			const h = 50;

			this.restartBtn = new SJ.TextureButton(x + w * 0, 0);
			this.restartBtn.w = w;
			this.restartBtn.h = h;
			this.restartBtn.hide();
			this.restartBtn.onMousePress = () => {
				hidePauseMenu();
				SJ.playerData.incrementDailyJumpsCount();
				SJ.userDataBar.updateDisplayData();
				SJ.afterRestart = true;
				SJ.restartGame();
			};
			this.addChild(this.restartBtn);

			const steeringInfoBtn = new SJ.TextureButton(x + w * 1, 0);
			steeringInfoBtn.w = w;
			steeringInfoBtn.h = h;
			steeringInfoBtn.hide();
			steeringInfoBtn.onMousePress = () => {
				SJ.steeringInfoDisplay.show();
				hidePauseMenu();
			};
			this.addChild(steeringInfoBtn);

			const exitBtn = new SJ.TextureButton(x + w * 2, 0);
			exitBtn.w = w;
			exitBtn.h = h;
			exitBtn.hide();
			exitBtn.onMousePress = () => {
				hidePauseMenu();
				SJ.backToMenu();
			};
			this.addChild(exitBtn);

			const hidePauseMenu = () => {
				menuTexture.hide();
				this.restartBtn.hide();
				steeringInfoBtn.hide();
				exitBtn.hide();
			};

			const showPauseMenu = () => {
				menuTexture.show();
				this.restartBtn.show();
				steeringInfoBtn.show();
				exitBtn.show();
			};

			const pauseBtn = new SJ.TextureButton(
				0,
				0,
				null,
				new SJ.SpriteSheetTexture2(gameSS, 0, 0, null, null, 0, 54, 120, 71),
				null,
				null,
				null,
				null,
				() => {
					if (menuTexture.isVisible) {
						SJ.main.setRunning(true);
						hidePauseMenu();
					} else {
						SJ.main.setRunning(false);
						showPauseMenu();
					}
				}
			);
			this.addChild(pauseBtn);
		}
	};

	SJ.JumpScoreDisplay = class extends SJ.UI.Element {
		constructor() {
			super(SJ.SCREEN_WIDTH - 170, 300);

			const gameSS = SJ.viewsSpriteSheets.gameSS;

			const x = 81.5;

			const backgroundTexture = new SJ.SpriteSheetTexture2(
				gameSS,
				0,
				0,
				null,
				null,
				0,
				1358,
				160,
				414
			);
			this.addChild(backgroundTexture);

			this.distanceScoreLabel = new SJ.Label(
				'180 M\n100 PKT',
				x,
				60,
				CENTER,
				CENTER,
				17,
				color(255),
				null,
				color(80),
				2
			);
			this.addChild(this.distanceScoreLabel);

			this.arbiterRatesLayout = new SJ.Layout(
				49,
				130,
				[
					new SJ.Label(
						'10',
						0,
						0,
						LEFT,
						CENTER,
						17,
						color(255),
						null,
						color(80),
						2
					),
					new SJ.Label(
						'11',
						0,
						0,
						LEFT,
						CENTER,
						17,
						color(255),
						null,
						color(80),
						2
					),
					new SJ.Label(
						'12',
						0,
						0,
						LEFT,
						CENTER,
						17,
						color(255),
						null,
						color(80),
						2
					),
					new SJ.Label(
						'13',
						0,
						0,
						LEFT,
						CENTER,
						17,
						color(255),
						null,
						color(80),
						2
					),
					new SJ.Label(
						'14',
						0,
						0,
						LEFT,
						CENTER,
						17,
						color(255),
						null,
						color(80),
						2
					),
				],
				18.5,
				'column',
				CENTER
			);
			this.arbiterRatesLayout.verticalAlign = TOP;
			this.arbiterRatesLayout.workingName = 'arl';
			this.addChild(this.arbiterRatesLayout);

			this.totalArbiterRatesScoreLabel = new SJ.Label(
				'',
				x,
				315,
				CENTER,
				CENTER,
				17,
				color(255),
				null,
				color(80),
				2
			);
			this.addChild(this.totalArbiterRatesScoreLabel);

			this.totalScoreLabel = new SJ.Label(
				'',
				x,
				370,
				CENTER,
				CENTER,
				17,
				color(255),
				null,
				color(80),
				2
			);
			this.addChild(this.totalScoreLabel);

			this.hide();
		}

		show(distance, distanceScore, arbiterRatesArray, arbiterRatesScore) {
			super.show();

			this.distanceScoreLabel.content = `${distance} M\n${distanceScore} PKT`;

			this.totalArbiterRatesScoreLabel.content = ``;
			this.totalScoreLabel.content = ``;

			const showTimes = [0, 300, 610, 920, 1340, 1650];
			let i = 0;

			this.arbiterRatesLayout.children = [];
			arbiterRatesArray.forEach((r) => {
				let rate = `${r}`;
				let textColor = color(255);
				let borderColor = color(0);

				if (rate.indexOf('X') !== -1) {
					rate = rate.split('X').join('');
					textColor = color(100, 100, 100, 140);
					borderColor = color(0, 0, 0, 0);
				}

				window.setTimeout(() => {
					this.arbiterRatesLayout.addChild(
						new SJ.Label(
							rate,
							0,
							0,
							CENTER,
							CENTER,
							17,
							textColor,
							null,
							borderColor,
							2
						)
					);
				}, showTimes[i]);

				i++;
			});

			window.setTimeout(() => {
				this.totalArbiterRatesScoreLabel.content = `${arbiterRatesScore} PKT`;
				this.totalScoreLabel.content = `${parseFloat(distanceScore) + parseFloat(arbiterRatesScore)
					} PKT`;
			}, showTimes[i]);
		}
	};

	SJ.JumpParamDisplay = class extends SJ.UI.Element {
		constructor() {
			super(SJ.SCREEN_MIDDLE_X - 435.5, SJ.SCREEN_MIDDLE_Y + 84.5 - 944 / 4);

			const gameSS = SJ.viewsSpriteSheets.gameSS;
			const gameSS2 = SJ.viewsSpriteSheets.gameSS2;

			const backgroundTexture = new SJ.SpriteSheetTexture2(
				gameSS,
				0,
				0,
				null,
				null,
				1106,
				944,
				872,
				414
			);
			this.addChild(backgroundTexture);

			this.fontSize = 18;

			this.jumpParamLayout = new SJ.Layout(420, 64, [], 13, 'column');

			this.jumpParamLayout.verticalAlign = TOP;
			this.jumpParamLayout.horizontalAlign = RIGHT;

			this.addChild(this.jumpParamLayout);

			this.landingAngleLabel = new SJ.Label(
				'20º',
				415,
				300,
				RIGHT,
				CENTER,
				this.fontSize
			);
			this.addChild(this.landingAngleLabel);

			this.landingHeightLabel = new SJ.Label(
				'100 M',
				415,
				352,
				RIGHT,
				CENTER,
				this.fontSize
			);
			this.addChild(this.landingHeightLabel);

			this.minWindSpeedLabel = new SJ.Label(
				'2 M/S',
				850,
				133,
				RIGHT,
				CENTER,
				this.fontSize
			);
			this.addChild(this.minWindSpeedLabel);

			this.maxWindSpeedLabel = new SJ.Label(
				'4 M/S',
				850,
				164,
				RIGHT,
				CENTER,
				this.fontSize
			);
			this.addChild(this.maxWindSpeedLabel);

			this.weatherConditionRating = new SJ.SpriteSheetTexture2(
				gameSS2,
				645,
				175,
				null,
				null,
				1258,
				0,
				210,
				75
			);
			this.addChild(this.weatherConditionRating);

			this.weatherConditionIcon = new SJ.SpriteSheetTexture2(
				gameSS2,
				787,
				60,
				null,
				null,
				191,
				0,
				55,
				55
			);
			this.addChild(this.weatherConditionIcon);

			this.restartBtn = new SJ.TextureButton(
				590,
				270,
				null,
				new SJ.SpriteSheetTexture2(gameSS, 0, 0, null, null, 900, 0, 265, 38)
			);
			this.restartBtn.onMousePress = () => {
				super.hide();
				SJ.restartGame();
			};
			this.addChild(this.restartBtn);

			this.continueTournamentBtn = new SJ.TextureButton(
				590,
				270,
				null,
				new SJ.SpriteSheetTexture2(gameSS, 0, 0, null, null, 105, 0, 265, 38)
			);
			this.continueTournamentBtn.onMousePress = () => {
				super.hide();
				SJ.tournament.continueTournament();
			};
			this.addChild(this.continueTournamentBtn);

			this.finishTournamentBtn = new SJ.TextureButton(
				590,
				270,
				null,
				new SJ.SpriteSheetTexture2(gameSS, 0, 0, null, null, 635, 0, 265, 38)
			);
			this.finishTournamentBtn.onMousePress = () => {
				super.hide();
				fetch(`${SJ.APILink}user/setFinishedTournaments.php`, {
					method: 'POST',
					headers: { 'Content-Type': 'application/json' },
					body: JSON.stringify({
						name: SJ.playerData.data['name'],
					}),
				})
					.then((res) => res.json())
					.then((data) => {
						if (data.type === 'error') console.log(data.message);
						else {
							SJ.playerData.data['finishedTournaments'] += 1;
							SJ.tournament.endTournament();
						}
					})
					.catch((e) => console.log(e));
			};
			this.addChild(this.finishTournamentBtn);

			this.exitBtn = new SJ.TextureButton(
				590,
				320,
				null,
				new SJ.SpriteSheetTexture2(gameSS, 0, 0, null, null, 370, 0, 265, 38)
			);
			this.exitBtn.onMousePress = () => {
				SJ.backToMenu();
			};
			this.addChild(this.exitBtn);

			this.shareBtn = new SJ.TextureButton(
				460,
				272,
				null,
				new SJ.SpriteSheetTexture2(gameSS, 0, 0, null, null, 468, 54, 107, 89),
				null,
				new SJ.SpriteSheetTexture2(gameSS, 0, 0, null, null, 361, 54, 107, 89)
			);
			this.shareBtn.disabled = true;
			this.shareBtn.onMousePress = () => { };
			this.shareBtn.workingName = 'f';
			this.addChild(this.shareBtn);

			super.hide();
		}

		show(
			distance,
			maxHeight,
			jumpMomentSpeed,
			jumpMomentDistance,
			maxSpeed,
			landingAngle,
			landingHeight,
			minWindSpeed,
			maxWindSpeed,
			weatherConditionRating,
			weatherConditionIcon
		) {
			super.show();

			const gameSS2 = SJ.viewsSpriteSheets.gameSS2;

			SJ.darkBackgroundCourtine.show();

			this.jumpParamLayout.children = [
				new SJ.Label(`${distance} M`, 0, 0, RIGHT, CENTER, this.fontSize),
				new SJ.Label(`${maxHeight} M`, 0, 0, RIGHT, CENTER, this.fontSize),
				new SJ.Label(
					`${jumpMomentSpeed} KM/H`,
					0,
					0,
					RIGHT,
					CENTER,
					this.fontSize
				),
				new SJ.Label(
					`${jumpMomentDistance} M OD PROGU`,
					0,
					0,
					RIGHT,
					CENTER,
					this.fontSize
				),
				new SJ.Label(`${maxSpeed} KM/H`, 0, 0, RIGHT, CENTER, this.fontSize),
			];

			this.landingAngleLabel.content = `${landingAngle}º`;
			this.landingHeightLabel.content = `${landingHeight} M`;

			this.minWindSpeedLabel.content = `${minWindSpeed} M/S`;
			this.maxWindSpeedLabel.content = `${maxWindSpeed} M/S`;

			const weatherConditionRatingData = [
				{ x: 1048, y: 0, w: 210, h: 75 },
				{ x: 1258, y: 0, w: 210, h: 75 },
				{ x: 1468, y: 0, w: 210, h: 75 },
				{ x: 1678, y: 0, w: 210, h: 75 },
				{ x: 0, y: 75, w: 210, h: 75 },
				{ x: 210, y: 75, w: 210, h: 75 },
				{ x: 420, y: 75, w: 210, h: 75 },
			];

			const weatherConditionIconData = [
				{ x: 191, y: 0, w: 55, h: 55 },
				{ x: 912, y: 0, w: 60, h: 65 },
				{ x: 0, y: 0, w: 49, h: 46 },
				{ x: 49, y: 0, w: 49, h: 48 },
				{ x: 147, y: 0, w: 44, h: 50 },
				{ x: 98, y: 0, w: 49, h: 48 },
			];

			// console.log(weatherConditionRating, weatherConditionIcon);

			this.weatherConditionRating.ssX =
				weatherConditionRatingData[weatherConditionRating].x;
			this.weatherConditionRating.ssY =
				weatherConditionRatingData[weatherConditionRating].y;
			this.weatherConditionRating.ssW =
				weatherConditionRatingData[weatherConditionRating].w;
			this.weatherConditionRating.ssH =
				weatherConditionRatingData[weatherConditionRating].h;

			this.weatherConditionIcon.ssX =
				weatherConditionIconData[weatherConditionIcon - 1].x;
			this.weatherConditionIcon.ssY =
				weatherConditionIconData[weatherConditionIcon - 1].y;
			this.weatherConditionIcon.ssW =
				weatherConditionIconData[weatherConditionIcon - 1].w;
			this.weatherConditionIcon.ssH =
				weatherConditionIconData[weatherConditionIcon - 1].h;

			this.restartBtn.show();

			this.continueTournamentBtn.hide();
			this.finishTournamentBtn.hide();

			if (SJ.tournament) {
				if (SJ.tournament.lastMap && SJ.tournament.endOfSeries) {
					this.finishTournamentBtn.show();
				} else {
					this.continueTournamentBtn.show();
				}

				this.restartBtn.hide();
			}
		}

		hide() {
			super.hide();
			SJ.darkBackgroundCourtine.hide();
		}
	};

	SJ.MapRecordDisplay = class extends SJ.UI.Element {
		constructor() {
			super(205, 682);

			const gameSS = SJ.viewsSpriteSheets.gameSS;

			const backgroundTexture = new SJ.SpriteSheetTexture2(
				gameSS,
				0,
				0,
				null,
				null,
				893,
				615,
				637,
				238
			);
			this.addChild(backgroundTexture);

			this.distanceLabel = new SJ.Label(
				'100 M',
				165,
				115.5,
				RIGHT,
				CENTER,
				16,
				color(178, 38, 38)
			);
			this.addChild(this.distanceLabel);

			this.scoreLabel = new SJ.Label(
				'120 PKT',
				213,
				134,
				RIGHT,
				CENTER,
				16,
				color(178, 38, 38)
			);
			this.addChild(this.scoreLabel);

			this.moneyLabel = new SJ.Label(
				'128000',
				0,
				0,
				LEFT,
				CENTER,
				18,
				color(255)
			);
			const moneyTexture = new SJ.SpriteSheetTexture2(
				gameSS,
				0,
				0,
				null,
				null,
				69,
				0,
				36,
				36,
				0.694,
				0.694
			);
			this.vipBonusTexture = new SJ.SpriteSheetTexture2(
				gameSS,
				0,
				0,
				null,
				null,
				0,
				0,
				69,
				22
			);

			const moneyLayout = new SJ.Layout(
				255,
				194,
				[this.moneyLabel, moneyTexture, this.vipBonusTexture],
				5,
				'row'
			);
			this.addChild(moneyLayout);

			this.hide();
		}

		show(distance, score, money) {
			super.show();

			this.distanceLabel.content = `${distance} M`;
			this.scoreLabel.content = `${score} PKT`;
			this.moneyLabel.content = `${money}`;

			if (SJ.playerData.data['isVip']) this.vipBonusTexture.show();
			else this.vipBonusTexture.hide();
		}
	};

	SJ.MedalDisplay = class extends SJ.UI.Element {
		constructor() {
			super(630, 660);

			const gameSS = SJ.viewsSpriteSheets.gameSS;
			const gameSS2 = SJ.viewsSpriteSheets.gameSS2;

			const backgroundTexture = new SJ.SpriteSheetTexture2(
				gameSS,
				0,
				0,
				null,
				null,
				0,
				944,
				400,
				356
			);
			this.addChild(backgroundTexture);

			this.medalTexture = new SJ.SpriteSheetTexture2(
				gameSS2,
				80,
				122,
				null,
				null,
				0,
				164,
				281,
				89
			);
			this.addChild(this.medalTexture);

			this.moneyLabel = new SJ.Label(
				'128000',
				0,
				0,
				LEFT,
				CENTER,
				18,
				color(185, 112, 48)
			);
			const moneyTexture = new SJ.SpriteSheetTexture2(
				gameSS,
				0,
				0,
				null,
				null,
				69,
				0,
				36,
				36,
				0.694,
				0.694
			);
			this.vipBonusTexture = new SJ.SpriteSheetTexture2(
				gameSS,
				0,
				0,
				null,
				null,
				0,
				0,
				69,
				22
			);

			const moneyLayout = new SJ.Layout(
				300,
				212,
				[this.moneyLabel, moneyTexture, this.vipBonusTexture],
				5,
				'row',
				CENTER
			);
			this.addChild(moneyLayout);

			super.hide();
		}

		show(medalName, bonusMoney) {
			const medalTexturesData = {
				Kryształowy: { x: 0, y: 164, w: 281, h: 89 },
				Brązowy: { x: 1549, y: 75, w: 258, h: 89 },
				Srebrny: { x: 1293, y: 75, w: 256, h: 88 },
				Złoty: { x: 281, y: 164, w: 243, h: 89 },
				Diamentowy: { x: 637, y: 164, w: 279, h: 98 },
			};

			this.medalTexture.ssX = medalTexturesData[medalName].x;
			this.medalTexture.ssY = medalTexturesData[medalName].y;
			this.medalTexture.ssW = medalTexturesData[medalName].w;
			this.medalTexture.ssH = medalTexturesData[medalName].h;

			this.moneyLabel.content = `${bonusMoney}`;

			if (SJ.playerData.data['isVip']) this.vipBonusTexture.show();
			else this.vipBonusTexture.hide();

			super.show();
		}
	};

	SJ.NewRankDisplay = class extends SJ.UI.Element {
		constructor() {
			super(1030, 660);

			const gameSS = SJ.viewsSpriteSheets.gameSS;
			const gameSS2 = SJ.viewsSpriteSheets.gameSS2;

			const backgroundTexture = new SJ.SpriteSheetTexture2(
				gameSS,
				0,
				0,
				null,
				null,
				753,
				944,
				353,
				357
			);
			this.addChild(backgroundTexture);

			this.moneyLabel = new SJ.Label(
				'128000',
				0,
				0,
				LEFT,
				CENTER,
				18,
				color(185, 112, 48)
			);
			const moneyTexture = new SJ.SpriteSheetTexture2(
				gameSS,
				0,
				0,
				null,
				null,
				69,
				0,
				36,
				36,
				0.694,
				0.694
			);
			this.vipBonusTexture = new SJ.SpriteSheetTexture2(
				gameSS,
				0,
				0,
				null,
				null,
				0,
				0,
				69,
				22
			);

			const moneyLayout = new SJ.Layout(
				105,
				185,
				[this.moneyLabel, moneyTexture, this.vipBonusTexture],
				5,
				'row',
				CENTER
			);
			moneyLayout.workingName = 'moneyLayout';
			this.addChild(moneyLayout);

			this.newRankTexture = new SJ.SpriteSheetTexture2(
				gameSS2,
				215,
				170,
				null,
				null,
				684,
				0,
				76,
				60
			);
			this.addChild(this.newRankTexture);

			this.newRankLabel = new SJ.Label(
				'Junior',
				151,
				110,
				CENTER,
				CENTER,
				17,
				color(0)
			);
			this.newRankLabel.workingName = 'foo';
			this.addChild(this.newRankLabel);

			this.hide();
		}

		show(newRankName, bonusMoney) {
			super.show();

			const gameSS2 = SJ.viewsSpriteSheets.gameSS2;

			const medalTexturesData = {
				Kadrowicz: { x: 1549, y: 75, w: 258, h: 89 },
				Klubowicz: { x: 316, y: 0, w: 76, h: 60 },
				'Legenda Skoków': { x: 972, y: 0, w: 76, h: 66 },
				'Medalista Olimpijski': { x: 392, y: 0, w: 76, h: 60 },
				Medalista: { x: 468, y: 0, w: 70, h: 60 },
				'Mistrz Kraju': { x: 538, y: 0, w: 70, h: 60 },
				'Mistrz Świata': { x: 608, y: 0, w: 76, h: 60 },
				Młodzik: { x: 684, y: 0, w: 76, h: 60 },
				Olimpijczyk: { x: 760, y: 0, w: 76, h: 60 },
				Zawodowiec: { x: 836, y: 0, w: 76, h: 60 },
			};

			this.newRankTexture = new SJ.SpriteSheetTexture2(
				gameSS2,
				215,
				170,
				null,
				null,
				medalTexturesData[newRankName].x,
				medalTexturesData[newRankName].y,
				medalTexturesData[newRankName].w,
				medalTexturesData[newRankName].h
			);

			this.newRankLabel.content = `${newRankName}!`;

			this.moneyLabel.content = `${bonusMoney}`;

			if (SJ.playerData.data['isVip']) this.vipBonusTexture.show();
			else this.vipBonusTexture.hide();
		}
	};

	SJ.CoachDisplay = class extends SJ.UI.Element {
		constructor() {
			super(SJ.SCREEN_MIDDLE_X - 446.5, 130);

			const gameSS = SJ.viewsSpriteSheets.gameSS;

			this.backgroundTexture = new SJ.SpriteSheetTexture2(
				gameSS,
				0,
				0,
				null,
				null,
				806,
				54,
				893,
				187
			);
			this.addChild(this.backgroundTexture);

			this.noMoreRankJumpsTexture = new SJ.SpriteSheetTexture2(
				gameSS,
				0,
				0,
				null,
				null,
				893,
				241,
				893,
				187
			);
			this.addChild(this.noMoreRankJumpsTexture);
			this.noMoreRankJumpsTexture.hide();

			this.demoTexture = new SJ.SpriteSheetTexture2(
				gameSS,
				0,
				0,
				null,
				null,
				0,
				241,
				893,
				187
			);
			this.addChild(this.demoTexture);
			this.demoTexture.hide();

			this.registerBtn = new SJ.TextureButton(
				545,
				108,
				null,
				null,
				null,
				null,
				null,
				null,
				() => SJ.registration.show(),
				null,
				null,
				null,
				null,
				null,
				null,
				null,
				null
			);
			this.registerBtn.setSize(150, 25);
			this.addChild(this.registerBtn);
			this.registerBtn.hide();

			this.moneyInfoTexture = new SJ.SpriteSheetTexture2(
				gameSS,
				0,
				0,
				null,
				null,
				0,
				428,
				893,
				187
			);
			this.addChild(this.moneyInfoTexture);

			this.coachTexture = new SJ.SpriteSheetTexture2(
				gameSS,
				0,
				0,
				null,
				null,
				0,
				615,
				893,
				187
			);
			this.addChild(this.coachTexture);

			this.scoreLabel = new SJ.Label(
				`126,8 PKT      `,
				0,
				0,
				LEFT,
				TOP,
				20,
				color(255),
				null,
				color(0),
				2
			);

			this.moneyLabel = new SJ.Label(
				'128000',
				0,
				0,
				LEFT,
				TOP,
				20,
				color(255),
				null,
				color(0),
				2
			);
			const moneyTexture = new SJ.SpriteSheetTexture2(
				gameSS,
				0,
				0,
				null,
				null,
				69,
				0,
				36,
				36,
				0.694,
				0.694
			);
			this.vipBonusTexture = new SJ.SpriteSheetTexture2(
				gameSS,
				0,
				0,
				null,
				null,
				0,
				0,
				69,
				22
			);

			this.dataLayout = new SJ.Layout(
				540,
				92,
				[this.scoreLabel, this.moneyLabel, moneyTexture, this.vipBonusTexture],
				5,
				'row',
				LEFT
			);
			this.dataLayout.workingName = 'moneyLayout';
			this.addChild(this.dataLayout);

			this.newPersonalRecordTexture = new SJ.SpriteSheetTexture2(
				gameSS,
				0,
				0,
				null,
				null,
				893,
				428,
				893,
				187
			);
			this.addChild(this.newPersonalRecordTexture);

			this.newPersonalRecordLabel = new SJ.Label(
				'120 M',
				606,
				123,
				LEFT,
				CENTER,
				24,
				color(255),
				null,
				color(23, 50, 82),
				3
			);
			this.addChild(this.newPersonalRecordLabel);

			this.newPersonalRecordLabel.hide();
			this.newPersonalRecordTexture.hide();
		}

		show(money, score, newRecord) {
			super.show();

			if (SJ.playerData.data['name'] !== 'Guest') {
				this.demoTexture.hide();
				this.registerBtn.hide();

				this.dataLayout.orginalX = 540;
				this.dataLayout.orginalY = 92;
				this.dataLayout.horizontalAlign = CENTER;

				if (
					SJ.tournament &&
					SJ.playerData.data['tournamentDailyJumpsCount'] >
					SJ.V.maxDailyJumpsCount
				) {
					this.moneyInfoTexture.hide();
					this.dataLayout.hide();

					this.noMoreRankJumpsTexture.show();
				} else if (
					!SJ.tournament &&
					SJ.playerData.data['worldcupDailyJumpsCount'] >
					SJ.V.maxDailyJumpsCount
				) {
					this.moneyInfoTexture.hide();
					this.dataLayout.hide();

					this.noMoreRankJumpsTexture.show();
				} else {
					this.moneyInfoTexture.show();
					this.dataLayout.show();

					this.noMoreRankJumpsTexture.hide();
				}
			} else {
				this.dataLayout.orginalX = 310;
				this.dataLayout.orginalY = 56;

				this.dataLayout.show();
				this.demoTexture.show();
				this.registerBtn.show();
				this.moneyInfoTexture.hide();
			}

			this.moneyLabel.content = `${money}`;
			this.scoreLabel.content = `${score} PKT      `;

			if (SJ.playerData.data['isVip']) this.vipBonusTexture.show();
			else this.vipBonusTexture.hide();

			if (newRecord > 0) {
				this.newPersonalRecordLabel.content = `${newRecord} M`;

				this.newPersonalRecordLabel.show();
				this.newPersonalRecordTexture.show();
			} else {
				this.newPersonalRecordLabel.hide();
				this.newPersonalRecordTexture.hide();
			}
		}
	};

	SJ.MobileSwipeSteeringInfo = class extends SJ.UI.Element {
		constructor() {
			super();

			this.mainGraphic = new SJ.SpriteSheetTexture2(
				'UI/jump-screen/suwak lewo-prawo.png',
				0,
				0,
				null,
				null,
				null,
				null,
				null,
				null,
				1.5,
				1.5
			);
			this.addChild(this.mainGraphic);

			super.hide();
		}

		show() {
			this.x = SJ.mouseScreenX - this.mainGraphic.w / 1.43;
			this.y = SJ.mouseScreenY - this.mainGraphic.h / 1.66;

			if (SJ.IS_MOBILE) super.show();
		}
	};

	SJ.SteeringInfoDisplay = class extends SJ.UI.Element {
		constructor() {
			super(SJ.SCREEN_MIDDLE_X - 1029 / 2, SJ.SCREEN_MIDDLE_Y - 627 / 2);

			const gameSS = SJ.viewsSpriteSheets.gameSS;

			if (SJ.playerData.data['name'] === 'Guest') this.x -= 100;

			this.mainTexture = new SJ.SpriteSheetTexture2(
				'UI/jump-screen/sterowanie_video_button.png',
				0,
				0,
				1029,
				627
			);
			this.addChild(this.mainTexture);

			this.videoButton = new SJ.TextureButton(764, 37.5, null, null);
			this.videoButton.w = 168;
			this.videoButton.h = 40;
			this.videoButton.onMousePress = () => this.createTutorialVideo();
			this.videoButton.workingName = 'video-btn';
			this.addChild(this.videoButton);

			this.hideBtn = new SJ.TextureButton(954, 37.5, null, null);
			this.hideBtn.w = 64;
			this.hideBtn.h = 40;
			this.hideBtn.onMousePress = () => {
				document.cookie = 'isNotFirstJump=true';
				this.hide();
				SJ.main.setRunning(true);
			};
			this.hideBtn.workingName = 'close-btn';
			this.addChild(this.hideBtn);

			this.hide();
		}

		createTutorialVideo() {

			const videoWrapper = document.createElement('div');
			videoWrapper.style = `position: absolute; left: 0; top: 0; width: 100%; height: 100%;`
			videoWrapper.classList.add('videoWrapper');
			document.querySelector('body').append(videoWrapper);

			this.video = createVideo('./skijump-js/sj-graphics/UI/jump-screen/video.mp4', () => {
				this.video.style(`width: 60%; height: auto; max-width: 1030px; z-index: 10; position: absolute; top: 50%; left: 50%; transform: translate(-50%, -50%);`);
				this.video.showControls();
				this.video.volume(0);
				this.video.play();
				this.video.onended(() => this.video.time(0));

				const canvas = document.querySelector('#defaultCanvas0');
				const videoElement = document.querySelector('body video');

				const closeButton = document.createElement('img');
				closeButton.src = './skijump-js/sj-graphics/UI/jump-screen/closeButton.png';
				closeButton.alt = 'close button';
				closeButton.style = `position: absolute; left: ${videoElement.offsetLeft + (videoElement.clientWidth / 2) - (canvas.clientWidth * 0.03)}px; top: ${videoElement.offsetTop - (videoElement.clientHeight / 2) - (canvas.clientWidth * 0.03)}px; width: ${canvas.clientWidth * 0.03}px; height: ${canvas.clientWidth * 0.03}px;`;
				closeButton.addEventListener('click', () => {
					document.querySelector('body .videoWrapper').remove();
					SJ.videoBackground.hide();
				});

				document.querySelector('body .videoWrapper').append(document.querySelector('body video'));
				document.querySelector('body .videoWrapper').append(closeButton);
			});

			this.video.size(1030, 580);

			SJ.videoBackground.show();
		}

		ifIsFirstJump() {
			if (SJ.playerData.data['name'] !== 'Guest') {
				if (
					SJ.playerData.data['successfulJumps'] === 0 ||
					SJ.playerData.data['worldcupDailyJumpsCount'] === 0 ||
					SJ.playerData.data['tournamentDailyJumpsCount'] === 0
				) {
					// this.show();
					this.createTutorialVideo();
				}
			} else {

				if (SJ.playerData.data['successfulJumps'] === 0) this.createTutorialVideo();
			}
		}

		show() {
			super.show();
			SJ.darkBackgroundCourtine.show();
			// console.log('SHOWED');
		}

		hide() {
			super.hide();
			SJ.darkBackgroundCourtine.hide();
		}
	};

	SJ.PaymentSuccessNotification = class extends SJ.UI.Element {
		constructor(bankSS) {
			super(SJ.SCREEN_MIDDLE_X, SJ.SCREEN_MIDDLE_Y);

			this.position = 'absolute';
			this.mouseMode = SJ.UI.MOUSE_MODE.BLOCK;

			this.mainTexture = new SJ.SpriteSheetTexture(
				bankSS,
				-107,
				-89,
				431,
				359,
				0,
				534,
				431,
				359,
				1,
				1,
				() => {
					if (SJ.showPaymentNotification) {
						this.show();
						SJ.showPaymentNotification = false;
					}
				}
			);
			this.addChild(this.mainTexture);

			this.closeBtn = new SJ.TextureButton(186, -166, null, null);
			this.closeBtn.w = 19;
			this.closeBtn.h = 18;
			this.closeBtn.onMousePress = () => {
				this.hide();
			};
			this.addChild(this.closeBtn);

			this.hide();
		}

		show = () => {
			fbq('track', 'Purchase', {
				currency: 'PLN',
				value: 25,
			});

			this.isVisible = true;
		};
	};

	SJ.RegisterDisplay = class extends SJ.UI.Element {
		constructor() {
			super(SJ.SCREEN_WIDTH - 353, SJ.SCREEN_MIDDLE_Y - 164.5);

			const gameSS = SJ.viewsSpriteSheets.gameSS;

			this.mainTexture = new SJ.SpriteSheetTexture2(
				gameSS,
				0,
				0,
				null,
				null,
				1530,
				615,
				333,
				329
			);
			this.addChild(this.mainTexture);

			this.registerBtn = new SJ.TextureButton(
				73.5,
				269,
				null,
				new SJ.SpriteSheetTexture2(gameSS, 0, 0, null, null, 1165, 0, 214, 45)
			);
			this.registerBtn.onMousePress = () => SJ.registration.show();

			this.addChild(this.registerBtn);

			if (SJ.playerData.data['name'] !== 'Guest') this.hide();
		}
	};

	SJ.VipAccountBuyDisplay = class extends SJ.UI.Element {
		constructor(dataArray) {
			super(840, 392);

			const vipClubSS = SJ.vipClubSS;

			this.backgroundTexture = new SJ.SpriteSheetTexture2(
				vipClubSS,
				20,
				50,
				null,
				null,
				465,
				515,
				674,
				355
			);
			this.addChild(this.backgroundTexture);

			const x = 52;
			const y = 140;
			const separatorY = 48;

			let i = 0;
			dataArray.forEach((element) => {
				const buyOption = new SJ.VipAccountBuyOption(
					element[0],
					element[1],
					x,
					y + separatorY * i
				);
				this.addChild(buyOption);
				i++;
			});
		}

		updateBuyButtons() {
			this.children.forEach((buyButton) => {
				if (buyButton.update) buyButton.update();
			});
		}
	};

	SJ.VipAccountBuyOption = class extends SJ.UI.Element {
		constructor(durationTimeInDays, price, x, y) {
			super(x, y);

			const vipClubSS = SJ.vipClubSS;

			const buyOptionBg = new SJ.SpriteSheetTexture2(
				vipClubSS,
				0,
				0,
				null,
				null,
				572,
				0,
				606,
				40
			);

			this.durationTimeInDays = durationTimeInDays;
			this.price = price;

			this.mainTexture = buyOptionBg;
			this.addChild(this.mainTexture);

			this.expirationTimeLabel = new SJ.Label(
				`${this.durationTimeInDays} DNI`,
				200,
				42.5,
				LEFT,
				BOTTOM,
				32,
				color(255)
			);
			this.addChild(this.expirationTimeLabel);

			this.buyButton = new SJ.TextureButton(
				480,
				2,
				price,
				new SJ.SpriteSheetTexture2(
					vipClubSS,
					0,
					0,
					null,
					null,
					422,
					0,
					150,
					40
				),
				null,
				new SJ.SpriteSheetTexture2(vipClubSS, 0, 0, null, null, 272, 0, 150, 40)
			);

			this.buyButton.label.fontSize = 26;
			this.buyButton.label.x -= 15;
			this.buyButton.label.y -= 3;

			this.addChild(this.buyButton);

			const buyFunction = () => {
				fetch(
					`https://skijumpsimulator.com/game/af8542a0e7f38c7b6c3268bf335a6865beacbb609fb70e14803fdda0d3a9aff9.php`
				)
					.then((res) => {
						return res.json();
					})
					.then((res) => {
						fetch(
							`${SJ.APILink}VIP/buyVIP.php?key=${res}&userName=${SJ.playerData.data['name']
							}&price=${price}&moneyToAdd=${0}&vipAccountDuration=${this.durationTimeInDays
							}`
						)
							.then((res) => {
								return res.json();
							})
							.then((res) => {
								// console.log(res);
								if (res == 'CORRECT') {
									fbq('track', 'Subscribe', {
										currency: 'PLN',
										value: 3,
									});

									SJ.playerData.data['VIPmoney'] -= price;
									SJ.playerData.data['VIPmoneySpent'] += price;

									const timestamp = round(Date.now() / 1000);

									if (SJ.playerData.data['vipAccountExpirationTime'] === 0)
										SJ.playerData.data['vipAccountExpirationTime'] += timestamp;

									SJ.playerData.data['vipAccountExpirationTime'] +=
										this.durationTimeInDays * 86400;
									SJ.playerData.data['isVip'] = true;

									SJ.userDataBar.updateDisplayData();
									SJ.itemsManager.calculateImtesVariables();

									SJ.updateVipBuyButtons();
								}
							});
					});
			};

			this.confirmationPopup = new SJ.VipClubConfirmationPopup(buyFunction);
			this.buyButton.onMousePress = () => {
				this.confirmationPopup.show();
			};

			this.buyButton.addChild(this.confirmationPopup);

			this.update();
		}

		update() {
			if (SJ.playerData.data['name'] !== 'Guest') {
				if (SJ.playerData.data['VIPmoney'] < this.price)
					this.buyButton.disabled = true;
			}
		}
	};

	SJ.MoneyBuyDisplay = class extends SJ.UI.Element {
		constructor(dataArray) {
			super(SJ.SCREEN_MIDDLE_X - 11.5 - 1493 / 2, 240);

			const vipClubSS = SJ.vipClubSS;

			this.backgroundTexture = new SJ.SpriteSheetTexture2(
				vipClubSS,
				0,
				0,
				null,
				null,
				0,
				321,
				1493,
				194
			);
			this.addChild(this.backgroundTexture);

			const x = 290;
			const y = 60;
			const separatorX = 180;

			let i = 0;
			dataArray.forEach((element) => {
				this.addChild(
					new SJ.MoneyBuyOption(element[0], element[1], x + separatorX * i, y)
				);
				i++;
			});
		}

		updateBuyButtons() {
			this.children.forEach((buyButton) => {
				if (buyButton.update) buyButton.update();
			});
		}
	};

	SJ.MoneyBuyOption = class extends SJ.UI.Element {
		constructor(moneyToAdd, price, x, y) {
			super(x, y);

			const vipClubSS = SJ.vipClubSS;

			this.moneyToAdd = moneyToAdd;
			this.price = price;

			this.moneyLabel = new SJ.Label(
				`${this.moneyToAdd}`,
				0,
				0,
				LEFT,
				CENTER,
				28,
				color(255)
			);

			const moneyTexture = new SJ.SpriteSheetTexture2(
				vipClubSS,
				0,
				0,
				null,
				null,
				236,
				0,
				36,
				35,
				0.69,
				0.69
			);

			const moneyLayout = new SJ.Layout(
				0,
				0,
				[this.moneyLabel, moneyTexture],
				5,
				'row',
				CENTER
			);
			this.addChild(moneyLayout);

			const text = new SJ.Label(
				'KUP ZA:',
				0,
				40,
				CENTER,
				CENTER,
				18,
				color(255)
			);
			this.addChild(text);

			this.buyButton = new SJ.TextureButton(
				-65,
				60,
				this.price,
				new SJ.SpriteSheetTexture2(
					vipClubSS,
					0,
					0,
					null,
					null,
					422,
					0,
					150,
					40
				),
				null,
				new SJ.SpriteSheetTexture2(vipClubSS, 0, 0, null, null, 272, 0, 150, 40)
			);

			this.buyButton.horizontalAlign = CENTER;
			this.buyButton.verticalAlign = CENTER;

			this.buyButton.label.fontSize = 26;
			this.buyButton.label.x -= this.price < 100 ? 12 : 15;
			this.buyButton.label.y -= 3;

			this.addChild(this.buyButton);

			const buyFunction = () => {
				fetch(
					`https://skijumpsimulator.com/game/af8542a0e7f38c7b6c3268bf335a6865beacbb609fb70e14803fdda0d3a9aff9.php`
				)
					.then((res) => {
						return res.json();
					})
					.then((res) => {
						fetch(
							`${SJ.APILink}VIP/buyVIP.php?key=${res}&userName=${SJ.playerData.data['name']
							}&price=${price}&moneyToAdd=${this.moneyToAdd
							}&vipAccountDuration=${0}`
						)
							.then((res) => {
								return res.json();
							})
							.then((res) => {
								if (res == 'CORRECT') {
									SJ.playerData.data['VIPmoney'] -= price;
									SJ.playerData.data['VIPmoneySpent'] += price;
									SJ.playerData.data['money'] += this.moneyToAdd;

									SJ.userDataBar.updateDisplayData();

									SJ.updateVipBuyButtons();
								}
							});
					});
			};

			this.confirmationPopup = new SJ.VipClubConfirmationPopup(buyFunction);
			this.buyButton.onMousePress = () => {
				this.confirmationPopup.show();
			};

			this.addChild(this.confirmationPopup);

			this.update();
		}

		update() {
			if (SJ.playerData.data['name'] !== 'Guest') {
				if (SJ.playerData.data['VIPmoney'] < this.price)
					this.buyButton.disabled = true;
			}
		}
	};

	SJ.SmsCodeCheckForm = class extends SJ.UI.Element {
		constructor(bankSS) {
			super(SJ.SCREEN_MIDDLE_X, SJ.SCREEN_MIDDLE_Y);

			this.position = 'absolute';
			this.paymentSecret = '';
			this.mouseMode = SJ.UI.MOUSE_MODE.BLOCK;

			this.mainGraphic = new SJ.SpriteSheetTexture(
				bankSS,
				-108,
				-90,
				null,
				null,
				1466,
				175,
				431,
				359
			);
			this.mainGraphic.mouseMode = SJ.UI.MOUSE_MODE.TEST_AND_BLOCK;
			this.addChild(this.mainGraphic);

			this.smsInput = document.querySelector('#bank-sms-code-input');

			this.inputButton = new SJ.TextureButton(-172, 25, ' ', null);
			this.inputButton.w = 342;
			this.inputButton.h = 37;
			this.inputButton.widthOffset = 0;
			this.inputButton.heightOffset = 0;
			this.inputButton.horizontalAlign = CENTER;

			this.inputButton.onMousePress = () => {
				window.setTimeout(() => this.smsInput.focus(), 0);
				this.inputButton.label.content =
					this.smsInput.value === '' ? '|' : this.smsInput.value;
			};

			this.inputButton.label.fontColor = color(0);
			this.inputButton.label.x += 157.5;
			this.inputButton.workingName = 'input';
			this.addChild(this.inputButton);

			this.smsInput.addEventListener('input', (e) => {
				this.inputButton.label.content = e.target.value;
			});

			this.paymentSuccessNotification = new SJ.PaymentSuccessNotification(
				bankSS
			);

			this.checkBtn = new SJ.TextureButton(-92, 98, null, null);
			this.checkBtn.w = 186;
			this.checkBtn.h = 31;
			this.checkBtn.onMousePress = () => {
				this.smsInput.value = '';

				fetch(
					`https://api.hotpay.pl/check_sms.php?sekret=${this.paymentSecret}&kod_sms=${this.inputButton.label.content}`
				)
					.then((res) => {
						return res.json();
					})
					.then((res) => {
						if (res) {
							this.inputButton.label.content = res.tresc;
							if (res.status === 'SUKCESS') {
								fetch(
									`${SJ.APILink}shop/confirmSmsPayment.php?price=${res.brutto}&userName=${SJ.playerData.data['name']}`
								)
									.then((res) => {
										return res.json();
									})
									.then((res) => {
										if (res.code === 'SUCCESS') {
											SJ.playerData.data['VIPmoney'] += parseInt(res.value);
											SJ.userDataBar.updateDisplayData();

											this.paymentSuccessNotification.show();
										}
									});
							}
						}
					});
			};
			this.checkBtn.horizontalAlign = CENTER;
			this.checkBtn.workingName = 'check';
			this.addChild(this.checkBtn);

			this.closeBtn = new SJ.TextureButton(184, -165, null, null);
			this.closeBtn.w = 19;
			this.closeBtn.h = 18;
			this.closeBtn.onMousePress = () => {
				this.hide();
				this.inputButton.label.content = '';
			};
			this.closeBtn.workingName = 'close';
			this.addChild(this.closeBtn);

			this.phoneNumberLabel = new SJ.Label(
				'79550.',
				129.5,
				-52,
				LEFT,
				CENTER,
				20,
				color(0),
				BOLD
			);
			this.phoneNumberLabel.workingName = 'phone';
			this.addChild(this.phoneNumberLabel);

			this.priceLabel = new SJ.Label(
				`KOSZT SMS: 00,00 PLN Z VAT`,
				0,
				158,
				CENTER,
				CENTER,
				16,
				color(0)
			);
			this.priceLabel.workingName = 'price';
			this.addChild(this.priceLabel);

			this.addChild(this.paymentSuccessNotification);

			this.hide();
			// this.show(10, 10, 'ff');
		}

		show(price, phoneNumber, paymentSecret) {
			this.phoneNumberLabel.content = `${phoneNumber}.`;
			this.priceLabel.content = `KOSZT SMS: ${price} PLN Z VAT`;
			this.paymentSecret = paymentSecret;

			this.inputButton.label.content = '';
			this.smsInput.value = '';

			window.setTimeout(() => this.smsInput.focus(), 0);
			this.inputButton.label.content = '|';

			super.show();
		}
	};

	SJ.RankJumpsBuyDisplay = class extends SJ.UI.Element {
		constructor() {
			super(400, 110);

			const vipClubSS = SJ.vipClubSS;

			this.mainTexture = new SJ.SpriteSheetTexture2(
				vipClubSS,
				0,
				0,
				null,
				null,
				0,
				130,
				1134,
				149
			);
			this.addChild(this.mainTexture);

			this.jumpsToAdd = 10;
			this.priceWorldCup = 12;
			this.priceTournament = 10;

			const buyFunction = (rankType) => {
				const price = rankType === 'tournament' ? this.priceTournament : this.priceWorldCup;

				fetch(
					`https://skijumpsimulator.com/game/af8542a0e7f38c7b6c3268bf335a6865beacbb609fb70e14803fdda0d3a9aff9.php`
				)
					.then((res) => {
						return res.json();
					})
					.then((res) => {
						fetch(
							`${SJ.APILink}VIP/buyRankJumps.php?key=${res}&userName=${SJ.playerData.data['name']}&price=${price}&jumpsToAdd=${this.jumpsToAdd}&rankType=${rankType}`
						)
							.then((res) => {
								return res.json();
							})
							.then((res) => {
								if (res == 'CORRECT') {
									fbq('track', 'AddPaymentInfo', {
										currency: 'PLN',
										value: 3,
									});

									SJ.playerData.data['VIPmoney'] -= price;
									SJ.playerData.data['VIPmoneySpent'] += price;

									if (SJ.playerData.data[`${rankType}DailyJumpsCount`] > 10)
										SJ.playerData.data[`${rankType}DailyJumpsCount`] = 10;

									SJ.playerData.data[`${rankType}DailyJumpsCount`] -=
										this.jumpsToAdd;

									const timestamp = Math.round(Date.now() / 1000);
									SJ.playerData.data[
										`lastBuyTimeOf${rankType
											.charAt(0)
											.toUpperCase()}${rankType.slice(1)}Jumps`
									] = timestamp;

									SJ.userDataBar.updateDisplayData();

									SJ.updateVipBuyButtons();
								}
							});
					});
			};

			this.worldcupJumpsBuyBtn = new SJ.TextureButton(
				260,
				90,
				this.priceWorldCup,
				new SJ.SpriteSheetTexture2(
					vipClubSS,
					0,
					0,
					null,
					null,
					422,
					0,
					150,
					40
				),
				null,
				new SJ.SpriteSheetTexture2(vipClubSS, 0, 0, null, null, 272, 0, 150, 40)
			);
			this.worldcupJumpsBuyBtn.horizontalAlign = CENTER;

			this.worldcupJumpsBuyBtn.label.fontSize = 26;
			this.worldcupJumpsBuyBtn.label.x -= 15;
			this.worldcupJumpsBuyBtn.label.y -= 3;

			this.addChild(this.worldcupJumpsBuyBtn);

			this.worldcupConfirmationPopup = new SJ.VipClubConfirmationPopup(() => {
				buyFunction('worldcup');
			}, true);
			this.worldcupJumpsBuyBtn.onMousePress = () => {
				this.worldcupConfirmationPopup.show();
			};
			this.worldcupJumpsBuyBtn.addChild(this.worldcupConfirmationPopup);

			this.tournamentsJumpsBuyBtn = new SJ.TextureButton(
				830,
				90,
				this.priceTournament,
				new SJ.SpriteSheetTexture2(
					vipClubSS,
					0,
					0,
					null,
					null,
					422,
					0,
					150,
					40
				),
				null,
				new SJ.SpriteSheetTexture2(vipClubSS, 0, 0, null, null, 272, 0, 150, 40)
			);
			this.tournamentsJumpsBuyBtn.onMousePress = () =>
				buyFunction('tournaments');
			this.tournamentsJumpsBuyBtn.horizontalAlign = CENTER;

			this.tournamentsJumpsBuyBtn.label.fontSize = 26;
			this.tournamentsJumpsBuyBtn.label.x -= 15;
			this.tournamentsJumpsBuyBtn.label.y -= 3;

			this.addChild(this.tournamentsJumpsBuyBtn);

			this.tournamentsConfirmationPopup = new SJ.VipClubConfirmationPopup(
				() => {
					buyFunction('tournament');
				},
				true
			);
			this.tournamentsJumpsBuyBtn.onMousePress = () => {
				this.tournamentsConfirmationPopup.show();
			};
			this.tournamentsJumpsBuyBtn.addChild(this.tournamentsConfirmationPopup);

			this.updateBuyButtons();
		}

		updateBuyButtons() {
			if (SJ.playerData.data['name'] !== 'Guest') {
				if (SJ.playerData.data['VIPmoney'] < this.priceWorldCup) {
					this.worldcupJumpsBuyBtn.disabled = true;
				}

				if (SJ.playerData.data['VIPmoney'] < this.priceTournament) {
					this.tournamentsJumpsBuyBtn.disabled = true;
				}

				if (
					new Date(
						SJ.playerData.data['lastBuyTimeOfWorldcupJumps'] * 1000
					).setHours(0, 0, 0, 0) >= new Date().setHours(0, 0, 0, 0)
				)
					this.worldcupJumpsBuyBtn.disabled = true;

				if (
					new Date(
						SJ.playerData.data['lastBuyTimeOfTournamentJumps'] * 1000
					).setHours(0, 0, 0, 0) >= new Date().setHours(0, 0, 0, 0)
				)
					this.tournamentsJumpsBuyBtn.disabled = true;
			}
		}
	};

	SJ.VipClubConfirmationPopup = class extends SJ.UI.Element {
		constructor(buyFunction, rankJumps = false) {
			super(SJ.SCREEN_MIDDLE_X, SJ.SCREEN_MIDDLE_Y);

			const vipClubSS = SJ.vipClubSS;

			this.position = 'absolute';

			if (rankJumps) {
				this.mainTexture = new SJ.SpriteSheetTexture2(
					vipClubSS,
					0,
					0,
					null,
					null,
					1134,
					130,
					285,
					191
				);
				this.x -= 285 / 2;
				this.y -= 191 / 2;
			} else {
				this.mainTexture = new SJ.SpriteSheetTexture2(
					vipClubSS,
					0,
					0,
					null,
					null,
					1285,
					0,
					289,
					130
				);
				this.x -= 289 / 2;
				this.y -= 130 / 2;
			}

			this.addChild(this.mainTexture);

			this.label = new SJ.Label(
				'Czy na pewno chcesz\ndokonać tego zakupu?',
				this.mainTexture.w / 2,
				40,
				CENTER,
				CENTER,
				22,
				color(255),
				null,
				color(70),
				2
			);
			this.addChild(this.label);

			this.yesBtn = new SJ.TextureButton(20, 84, null, null);
			this.yesBtn.setSize(126, 31);
			this.yesBtn.onMousePress = () => {
				buyFunction();
				this.hide();
			};
			this.addChild(this.yesBtn);

			this.noBtn = new SJ.TextureButton(153, 84, null, null);
			this.noBtn.setSize(126, 31);
			this.noBtn.onMousePress = () => {
				this.hide();
			};
			this.addChild(this.noBtn);

			this.hide();
		}
	};

	SJ.JumpDataBox = class extends SJ.LabelWithBackground {
		constructor(titleText, label, x, y, w, h) {
			super(label, x, y, w, h, 16, color(255), color(0), RIGHT);
			this.titleText = titleText;
			this.setData('');
			this.color = color(40, 50, 120);
		}

		setData(data) {
			this.label.content = this.titleText + '\n' + data;
		}
	};

	SJ.LoginDataDisplay = class extends SJ.UI.Element {
		constructor(x, y, w, h) {
			super(x, y, w, h);

			const padding = 10;

			this.playername = new SJ.Label(
				SJ.playerData.data['name'],
				w / 2,
				10,
				CENTER,
				CENTER,
				24
			);
			this.loginBtn = new SJ.Button(
				this.btnCaption,
				w / 2 - 45,
				30,
				90,
				40,
				null,
				() => {
					if (this.btnCaption === 'Zaloguj') SJ.registration.show();
					else if (sessionStorage.getItem('playername')) {
						sessionStorage.removeItem('playername');
						sessionStorage.removeItem('playerpassword');
						SJ.playerData.setDefault();

						FB.getLoginStatus(function (response) {
							if (response.status === 'connected') FB.logout();
						});

						location = window.location.origin + '/game';

						// console.log('LOGOUT');
					}
				}
			);
			this.background = new SJ.DrawableRect(
				w / 2 - (w + padding) / 2,
				0 - padding,
				w + padding,
				h + padding,
				color(0, 0, 50)
			);
			this.loginBtn.label.fontSize = 20;

			this.addChild(this.background);
			this.addChild(this.playername);
			this.addChild(this.loginBtn);
		}

		draw() {
			this.btnCaption =
				SJ.playerData.data['name'] === 'Guest' ? 'Zaloguj' : 'Wyloguj';

			this.playername.content = SJ.playerData.data['name'];

			if (SJ.playerData.data['isVip'])
				this.playername.fontColor = color(242, 188, 43);

			this.loginBtn.label.content = this.btnCaption;
		}
	};

	SJ.RankDisplay = class extends SJ.UI.Element {
		constructor(
			x,
			y,
			rankData,
			itemsData,
			medalsData,
			tableMainTextrue = new SJ.Texture(
				'../sj-graphics/UI/fame-gallery/table-main-graphic.png',
				0,
				0
			),
			worldCupMainTexture = new SJ.Texture(
				'../sj-graphics/UI/fame-gallery/world-cup-main-texture.png',
				0,
				5
			),
			tournamentMainTexture = new SJ.Texture(
				'../sj-graphics/UI/fame-gallery/tournament-main-texture.png',
				0,
				5
			),
			bestJumpsMainTexture = new SJ.Texture(
				'../sj-graphics/UI/fame-gallery/best-jumps-main-texture.png',
				0,
				5
			)
		) {
			super(x, y);

			const fameGallerySS2 = SJ.fameGallerySS2;

			this.x = x;
			this.y = y;

			this.rowHeight = 30;
			this.rowSeparation = 0;

			this.pageIndex = 0;

			this.rowsOnPage = 14;
			this.firstRowIndex = 0;

			this.scrollSpeed = 300;

			this.mainTexture = tableMainTextrue;

			this.worldCupMainTexture = worldCupMainTexture;
			this.tournamentMainTexture = tournamentMainTexture;
			this.bestJumpsMainTexture = bestJumpsMainTexture;

			this.shadowTexture = new SJ.SpriteSheetTexture(
				fameGallerySS2,
				0,
				222.5,
				null,
				null,
				0,
				152,
				1519,
				87
			);

			this.onMouseWheelMoveUp = this.scrollUp;
			this.onMouseWheelMoveDown = this.scrollDown;

			this.scrollGraphic = new SJ.SpriteSheetTexture2(
				fameGallerySS2,
				1485,
				8,
				null,
				null,
				1829,
				152,
				28,
				105
			);
			this.scrollGraphic.workingName = 'scroll';

			this.moveTopBox = new SJ.TextureButton(1485, -20, null, null);
			this.moveTopBox.widthOffset = 0;
			this.moveTopBox.heightOffset = 0;
			this.moveTopBox.w = 28;
			this.moveTopBox.h = 28;
			this.moveTopBox.mouseMode = SJ.UI.MOUSE_MODE.TEST_AND_PASS;
			this.moveTopBox.onMousePress = () => {
				this.scrollUp();
			};
			this.moveTopBox.onMouseEnter = () => {
				SJ.dragDisable = true;
			};
			this.moveTopBox.onMouseLeave = () => {
				SJ.dragDisable = false;
			};

			this.moveBottomBox = new SJ.TextureButton(1485, 113, null, null);
			this.moveBottomBox.widthOffset = 0;
			this.moveBottomBox.heightOffset = 0;
			this.moveBottomBox.w = 28;
			this.moveBottomBox.h = 28;
			this.moveBottomBox.mouseMode = SJ.UI.MOUSE_MODE.TEST_AND_PASS;
			this.moveBottomBox.onMousePress = () => {
				this.scrollDown();
			};
			this.moveBottomBox.onMouseEnter = () => {
				SJ.dragDisable = true;
			};
			this.moveBottomBox.onMouseLeave = () => {
				SJ.dragDisable = false;
			};

			this.scrollDetectBox = new SJ.UI.Element(
				0,
				0,
				SJ.SCREEN_WIDTH,
				SJ.SCREEN_HEIGHT
			);
			this.scrollDetectBox.mouseMode = SJ.UI.MOUSE_MODE.TEST_AND_PASS;

			let mouseStartPosY;

			this.scrollDetectBox.onMousePress = () => {
				if (SJ.dragDisable) return;

				mouseStartPosY = SJ.mouseScreenY;
			};
			this.scrollDetectBox.onMouseRelease = () => {
				if (SJ.dragDisable) return;

				let scroll = mouseStartPosY - SJ.mouseScreenY;
				scroll = scroll / 100;

				if (scroll < 0) {
					scroll = Math.round(scroll * -1);

					for (let i = 0; i <= scroll; i++) this.scrollUp();
				} else if (scroll > 0) {
					scroll = Math.round(scroll);

					for (let i = 0; i <= scroll; i++) this.scrollDown();
				}
			};

			this.scrollY = 0;
			this.scrollYBottomMax = 0;

			this.rowsCount = 0;

			this.paginationBg = new SJ.Texture(
				'UI/fame-gallery/podswietlenie_wersu.png',
				581,
				458
			);

			this.paginationArrows2 = new SJ.Texture(
				'UI/fame-gallery/arrows2.png',
				649,
				467
			);
			this.paginationArrows2.mouseMode = SJ.UI.MOUSE_MODE.TEST_AND_BLOCK;

			this.paginationArrows = new SJ.Texture(
				'UI/fame-gallery/arrows.png',
				685,
				467
			);
			this.paginationArrows.mouseMode = SJ.UI.MOUSE_MODE.TEST_AND_BLOCK;

			this.pageIndexLabel = new SJ.Label(
				this.pageIndex * 100,
				750,
				473,
				CENTER,
				CENTER
			);

			this.startPageArrow = new SJ.TextureButton(685 - 36, 467, null, null);
			this.startPageArrow.mouseMode = SJ.UI.MOUSE_MODE.TEST_AND_BLOCK;
			this.startPageArrow.h = 20;

			this.prevPageArrow = new SJ.TextureButton(685, 467, null, null);
			this.prevPageArrow.mouseMode = SJ.UI.MOUSE_MODE.TEST_AND_BLOCK;
			this.prevPageArrow.h = 20;

			this.nextPageArrow = new SJ.TextureButton(785, 467, null, null);
			this.nextPageArrow.mouseMode = SJ.UI.MOUSE_MODE.TEST_AND_BLOCK;
			this.nextPageArrow.h = 20;

			this.endPageArrow = new SJ.TextureButton(785 + 36, 467, null, null);
			this.endPageArrow.mouseMode = SJ.UI.MOUSE_MODE.TEST_AND_BLOCK;
			this.endPageArrow.h = 20;

			this.startPageArrow.onMousePress = () => {
				this.pageIndex = 0;

				this.pageIndexLabel.content = this.pageIndex * 100;

				this.scrollY = 0;
				this.changeScrollGraphicPosition();

				this.rowsCount = 0;
				this.createRows();

				this.scrollDown();
				this.scrollUp();
			};

			this.prevPageArrow.onMousePress = () => {
				this.pageIndex = Math.min(
					Math.max(0, this.pageIndex - 1),
					Math.ceil(this.rankData.length / 100) - 1
				);

				this.pageIndexLabel.content = this.pageIndex * 100;

				this.scrollY = 0;
				this.changeScrollGraphicPosition();

				this.rowsCount = 0;
				this.createRows();

				this.scrollDown();
				this.scrollUp();
			};

			this.nextPageArrow.onMousePress = () => {
				this.pageIndex = Math.min(
					Math.max(0, this.pageIndex + 1),
					Math.ceil(this.rankData.length / 100) - 1
				);

				this.pageIndexLabel.content = this.pageIndex * 100;

				this.scrollY = 0;
				this.changeScrollGraphicPosition();

				this.rowsCount = 0;
				this.createRows();

				this.scrollDown();
				this.scrollUp();
			};

			this.endPageArrow.onMousePress = () => {
				this.pageIndex = Math.ceil(this.rankData.length / 100) - 1;

				this.pageIndexLabel.content = this.pageIndex * 100;

				this.scrollY = 0;
				this.changeScrollGraphicPosition();

				this.rowsCount = 0;
				this.createRows();

				this.scrollDown();
				this.scrollUp();
			};

			this.findUserPositionInRankBtn = new SJ.TextureButton(
				600,
				500,
				null,
				new SJ.SpriteSheetTexture(
					fameGallerySS2,
					0,
					0,
					null,
					null,
					1475,
					30,
					344,
					44
				),
				null,
				null,
				null,
				null,
				() => this.findUserPositionInRank(SJ.playerData.data['name'])
			);
		}

		updateRankData(
			rankData,
			itemsData,
			medalsData,
			rankType,
			sortBy = 'totalScore',
			filterBy = 'jumpScore'
		) {
			this.children = [];
			this.scrollY = 0;
			this.rowsCount = 0;

			this.addChild(this.mainTexture);

			switch (rankType) {
				case 'WorldCup':
					this.addChild(this.worldCupMainTexture);
					break;

				case 'Tournament':
					this.addChild(this.tournamentMainTexture);
					break;

				case 'Jumps':
					this.addChild(this.bestJumpsMainTexture);
					break;
			}

			this.scrollGraphic.y = 8;

			this.addChild(this.scrollGraphic);
			this.addChild(this.moveTopBox);
			this.addChild(this.moveBottomBox);

			// this.childrenEnd
			this.addChild(this.shadowTexture);
			this.addChild(this.scrollDetectBox);
			this.addChild(this.paginationBg);
			this.addChild(this.paginationArrows2);
			this.addChild(this.paginationArrows);
			this.addChild(this.pageIndexLabel);
			this.addChild(this.startPageArrow);
			this.addChild(this.endPageArrow);
			this.addChild(this.prevPageArrow);
			this.addChild(this.nextPageArrow);
			this.addChild(this.findUserPositionInRankBtn);

			this.rawRankData = rankData;
			this.itemsData = itemsData;
			this.medalsData = medalsData;

			this.filterRankArray(filterBy);
			this.sortRows(sortBy);
			this.createRows();

			this.scrollDown();
			this.scrollUp();
		}

		filterRankArray = (filterBy) => {
			let workingArray = this.rawRankData;
			let bestRowsArray = [];

			while (workingArray.length > 0) {
				let playerName = workingArray[0]['name'];

				let singlePlayerArray = workingArray.filter(
					(record) => record['name'] === playerName
				);

				let playerBestJumpRow = singlePlayerArray[0];

				for (let i = 1; i < singlePlayerArray.length; i++) {
					const curRow = parseFloat(singlePlayerArray[i][filterBy]);
					const bestRow = parseFloat(playerBestJumpRow[filterBy]);

					if (curRow > bestRow) playerBestJumpRow = singlePlayerArray[i];
				}

				bestRowsArray.push(playerBestJumpRow);
				workingArray = workingArray.filter((e) => e['name'] !== playerName);
			}

			this.rankData = bestRowsArray;
		};

		sortRows = (sortBy) => {
			let workingArray = [];

			switch (sortBy) {
				case 'totalScore':
					workingArray = this.rankData.sort((a, b) => {
						if (parseFloat(a['score']) > parseFloat(b['score'])) return -1;
						else if (parseFloat(a['score']) < parseFloat(b['score'])) return 1;

						return 0;
					});
					break;

				case 'jumpScore':
					workingArray = this.rankData.sort((a, b) => {
						if (parseFloat(a['jumpScore']) > parseFloat(b['jumpScore']))
							return -1;
						else if (parseFloat(a['jumpScore']) < parseFloat(b['jumpScore']))
							return 1;

						return 0;
					});
					break;

				case 'jumpDistance':
					workingArray = this.rankData.sort((a, b) => {
						if (parseFloat(a['jumpDistance']) > parseFloat(b['jumpDistance']))
							return -1;
						else if (
							parseFloat(a['jumpDistance']) < parseFloat(b['jumpDistance'])
						)
							return 1;

						return 0;
					});
					break;
			}

			this.rankData = workingArray;

			const userIndex = this.rankData.findIndex(
				(item) => item.name === SJ.playerData.data.name
			);

			if (SJ.playerData.data.name !== 'Guest')
				this.currentPlayerPosition = {
					pageIndex: Math.floor(userIndex / 100),
					position: userIndex + 1,
				};
		};

		createRows = () => {
			this.childrenStart = [...this.children].filter(
				(item, index) => index < 5
			);
			this.childrenEnd = [...this.children].filter(
				(item, index) => index > [...this.children].length - 12
			);

			this.children = [...this.childrenStart];

			const rowWidth = 1473;
			const rowHeight = 30;
			const marginTop = 50;

			const pageStartIndex = 100 * this.pageIndex;

			for (let i = pageStartIndex; i < pageStartIndex + 100; i++) {
				if (this.rankData[i]) {
					const userName = this.rankData[i]['name'];
					const userItemsData = this.itemsData.filter(
						(e) => e.userName === userName
					);
					const userMedalsData = this.medalsData.filter(
						(e) => e.userName === userName
					);

					this.addChild(
						new SJ.UserRankRow(
							5,
							this.rowsCount * rowHeight + marginTop,
							rowWidth,
							rowHeight,
							this.rankData[i],
							userItemsData,
							userMedalsData,
							i + 1
						)
					);

					this.rowsCount++;
				} else break;
			}

			this.children.push(...this.childrenEnd);

			this.scrollDown();
			this.scrollUp();
		};

		hideRowsPopups() {
			for (let i = 5; i < this.children.length - 11; i++) {
				this.children[i].hidePopups();
			}
		}

		scrollDown() {
			this.scrollY += this.scrollSpeed;

			if (this.scrollY > this.scrollYBottomMax) {
				this.scrollY = this.scrollYBottomMax;
			} else {
				for (let i = 5; i < this.children.length - 11; i++) {
					this.children[i].y -= this.scrollSpeed;

					if (this.children[i].y > 35 && this.children[i].y < 500)
						this.children[i].show();
					else this.children[i].hide();
				}
			}

			this.changeScrollGraphicPosition();
		}

		scrollUp() {
			this.scrollY -= this.scrollSpeed;

			if (this.scrollY < 0) this.scrollY = 0;
			else {
				for (let i = 5; i < this.children.length - 11; i++) {
					this.children[i].y += this.scrollSpeed;

					if (this.children[i].y > 35 && this.children[i].y < 500)
						this.children[i].show();
					else this.children[i].hide();
				}
			}

			this.changeScrollGraphicPosition();
		}

		changeScrollGraphicPosition() {
			this.scrollYBottomMax = this.rowHeight * (this.rowsCount - 9);
			this.scrollGraphic.y = map(
				this.scrollY,
				0,
				this.scrollYBottomMax,
				8,
				424
			);
			this.moveTopBox.y = this.scrollGraphic.y - 28;
			this.moveBottomBox.y = this.scrollGraphic.y + 105;
		}

		findUserPositionInRank(userName) {
			if (userName === 'Guest') return null;
			if (
				this.currentPlayerPosition.position <=
				100 * this.pageIndex + 1 + 13
			) {
				this.children[
					this.currentPlayerPosition.position -
					(this.currentPlayerPosition.pageIndex * 100 + 1) +
					5
				].hoverTexture.show();
				return null;
			}

			let pos = this.currentPlayerPosition.position - 1;

			if (this.currentPlayerPosition.pageIndex !== this.pageIndex) {
				this.pageIndex = this.currentPlayerPosition.pageIndex;

				this.pageIndexLabel.content = this.pageIndex * 100;

				this.scrollY = 0;
				this.changeScrollGraphicPosition();

				this.rowsCount = 0;
				this.createRows();

				this.scrollDown();
				this.scrollUp();
			}

			pos = (pos % 100) * this.rowHeight;

			while (this.scrollY + this.scrollSpeed < pos) {
				this.scrollDown();
			}

			this.children[
				this.currentPlayerPosition.position -
				(this.currentPlayerPosition.pageIndex * 100 + 1) +
				5
			].hoverTexture.show();
		}
	};

	SJ.UserRankRow = class extends SJ.UI.Element {
		constructor(
			x,
			y,
			w,
			h,
			userData,
			userEquipmentData,
			userMedalsData,
			position
		) {
			super(x, y, w, h);

			const fameGallerySS = SJ.fameGallerySS;
			const fameGallerySS2 = SJ.fameGallerySS2;

			this.mouseMode = SJ.UI.MOUSE_MODE.TEST_AND_BLOCK;

			this.userData = userData;
			this.userEquipmentData = userEquipmentData;
			this.userMedalsData = userMedalsData;

			const labelsY = this.h / 2;

			const RowDataLabel = class extends SJ.Label {
				constructor(content, x) {
					super(content, x, labelsY, CENTER, CENTER, 18);
				}
			};

			const positionLabel = new RowDataLabel(`${position}.`, 60);
			this.addChild(positionLabel);

			const userNameLayout = new SJ.Layout(
				145,
				labelsY,
				[],
				5,
				'row',
				LEFT,
				false,
				260,
				28
			);

			userNameLayout.fixedWidth = true;
			userNameLayout.fixedHeight = true;

			userNameLayout.onMouseEnter = () => {
				this.parent.hideRowsPopups();
				this.equipmentDisplay.show();
			};
			userNameLayout.onMouseLeave = () => {
				this.equipmentDisplay.hide();
			};
			userNameLayout.mouseMode = SJ.UI.MOUSE_MODE.TEST_AND_BLOCK;

			const userNameLabel = new RowDataLabel(this.userData.name, 145);
			const vipMarker = new SJ.SpriteSheetTexture2(
				fameGallerySS2,
				0,
				0,
				null,
				null,
				104,
				0,
				24,
				14
			);
			vipMarker.fitToWidth = 27;
			vipMarker.hide();

			const timestamp = round(Date.now() / 1000);

			if (this.userData.vipAccountExpirationTime >= timestamp) {
				userNameLabel.fontColor = color(242, 188, 43);
				vipMarker.show();
			}

			userNameLayout.addChild(userNameLabel);
			userNameLayout.addChild(vipMarker);
			this.addChild(userNameLayout);

			const rankLayout = new SJ.Layout(
				417,
				labelsY,
				[],
				5,
				'row',
				LEFT,
				false,
				260,
				28
			);

			rankLayout.fixedWidth = true;
			rankLayout.fixedHeight = true;

			rankLayout.onMouseEnter = () => {
				this.parent.hideRowsPopups();
				this.medalsDisplay.show();
			};
			rankLayout.onMouseLeave = () => {
				this.medalsDisplay.hide();
			};
			rankLayout.onMousePress = () => {
				// SJ.ScreensManager.changeScreen(SJ.ScreensManager.screens.career, this.userData.name);
			};
			rankLayout.mouseMode = SJ.UI.MOUSE_MODE.TEST_AND_BLOCK;

			const rankImgsData = {
				Junior: { x: 707, y: 0, w: 24, h: 24 },
				Kadrowicz: { x: 755, y: 0, w: 27, h: 26 },
				Klubowicz: { x: 28, y: 0, w: 35, h: 20 },
				'Legenda Skoków': { x: 225, y: 26, w: 25, h: 27 },
				Medalista: { x: 63, y: 0, w: 26, h: 22 },
				'Medalista Olimpijski': { x: 0, y: 26, w: 25, h: 26 },
				'Mistrz Kraju': { x: 416, y: 26, w: 32, h: 28 },
				'Mistrz Świata': { x: 731, y: 0, w: 24, h: 25 },
				Młodzik: { x: 0, y: 0, w: 28, h: 19 },
				Olimpijczyk: { x: 684, y: 0, w: 23, h: 23 },
				Zawodowiec: { x: 193, y: 26, w: 32, h: 26 },
			};

			const rankImage = new SJ.SpriteSheetTexture2(
				fameGallerySS,
				0,
				0,
				null,
				null,
				rankImgsData[this.userData.rank].x,
				rankImgsData[this.userData.rank].y,
				rankImgsData[this.userData.rank].w,
				rankImgsData[this.userData.rank].h
			);
			const rankLabel = new RowDataLabel(this.userData.rank.toUpperCase(), 0);

			rankLayout.addChild(rankImage);
			rankLayout.addChild(rankLabel);

			this.addChild(rankLayout);

			if (this.userData.tScore) {
				const scoreLabel = new RowDataLabel(`${this.userData.score} PKT`, 778);
				const tournamentScoreLabel = new RowDataLabel(
					`${this.userData.tScore} PKT`,
					978
				);

				this.addChild(scoreLabel);
				this.addChild(tournamentScoreLabel);
			} else {
				const scoreLabel = new RowDataLabel(`${this.userData.score} PKT`, 880);
				this.addChild(scoreLabel);
			}

			const bestJumpLayout = new SJ.Layout(
				1085,
				labelsY,
				[],
				null,
				'row',
				LEFT,
				true,
				380,
				this.h
			);
			this.addChild(bestJumpLayout);

			const bestJumpMapNameLabel = new RowDataLabel(
				this.userData.mapName.toUpperCase(),
				1085
			);
			bestJumpMapNameLabel.align = LEFT;
			bestJumpLayout.addChild(bestJumpMapNameLabel);

			const bestJumpScoreLabel = new RowDataLabel(
				`${this.userData.jumpScore.toUpperCase()} PKT`,
				1350
			);
			bestJumpScoreLabel.align = RIGHT;

			const bestJumpDistanceLabel = new RowDataLabel(
				`${this.userData.jumpDistance.toUpperCase()} M`,
				1463
			);
			bestJumpDistanceLabel.align = RIGHT;

			this.addChild(bestJumpScoreLabel);
			this.addChild(bestJumpDistanceLabel);

			bestJumpLayout.onMouseEnter = () => {
				this.parent.hideRowsPopups();
				this.bestJumpDisplay.show();
			};

			bestJumpLayout.onMouseLeave = () => {
				this.bestJumpDisplay.hide();
			};

			bestJumpLayout.mouseMode = SJ.UI.MOUSE_MODE.TEST_AND_BLOCK;

			this.bestJumpDisplay = new SJ.UserBestJumpDisplay(
				600,
				410,
				this.userData
			);
			this.addChild(this.bestJumpDisplay);

			this.equipmentDisplay = new SJ.UserEquipmentDisplay(
				450,
				350,
				this.userEquipmentData,
				this.userData['successfulJumps'],
				this.userData['joinDate'],
				this.userData['brokenMapRecords']
			);
			this.equipmentDisplay.hide();
			this.addChild(this.equipmentDisplay);

			this.medalsDisplay = new SJ.UserMedalsDisplay(
				720,
				410,
				this.userMedalsData
			);
			this.addChild(this.medalsDisplay);

			this.hoverTexture = new SJ.SpriteSheetTexture2(
				fameGallerySS2,
				0,
				0,
				null,
				null,
				0,
				30,
				1475,
				30
			);
			this.hoverTexture.hide();
			this.addChild(this.hoverTexture);
		}

		onMouseEnter() {
			this.hoverTexture.show();
		}

		onMouseLeave() {
			this.hoverTexture.hide();
		}

		hidePopups() {
			this.bestJumpDisplay.hide();
			this.medalsDisplay.hide();
			this.equipmentDisplay.hide();
		}
	};

	SJ.UserEquipmentDisplay = class extends SJ.UI.Element {
		constructor(
			x,
			y,
			equipmentData,
			successfulJumps,
			joinDate,
			brokenMapRecords
		) {
			super(x, y);

			const fameGallerySS2 = SJ.fameGallerySS2;

			this.position = 'absolute';
			this.equipmentData = equipmentData;

			const mainGraphic = new SJ.SpriteSheetTexture2(
				fameGallerySS2,
				0,
				0,
				null,
				null,
				1297,
				369,
				334,
				499
			);
			this.addChild(mainGraphic);

			const x1 = 78;
			const x2 = 301;

			const skisLevelLabel = new SJ.Label(
				this.getItemLevel('skis'),
				parseInt(this.getItemLevel('skis')) > 99 ? x1 - 14 : x1,
				210,
				CENTER,
				CENTER,
				24,
				color(255),
				null,
				color(40),
				3
			);
			this.addChild(skisLevelLabel);

			const suitLevelLabel = new SJ.Label(
				this.getItemLevel('suit'),
				parseInt(this.getItemLevel('skis')) > 99 ? x1 - 14 : x1,
				310,
				CENTER,
				CENTER,
				24,
				color(255),
				null,
				color(40),
				3
			);
			this.addChild(suitLevelLabel);

			const bindingsLevelLabel = new SJ.Label(
				this.getItemLevel('bindings'),
				parseInt(this.getItemLevel('skis')) > 99 ? x1 - 14 : x1,
				410,
				CENTER,
				CENTER,
				24,
				color(255),
				null,
				color(40),
				3
			);
			this.addChild(bindingsLevelLabel);

			const helmetLevelLabel = new SJ.Label(
				this.getItemLevel('helmet'),
				parseInt(this.getItemLevel('skis')) > 99 ? x2 - 14 : x2,
				110,
				CENTER,
				CENTER,
				24,
				color(255),
				null,
				color(40),
				3
			);
			this.addChild(helmetLevelLabel);

			const gogglesLevelLabel = new SJ.Label(
				this.getItemLevel('goggles'),
				parseInt(this.getItemLevel('skis')) > 99 ? x2 - 14 : x2,
				210,
				CENTER,
				CENTER,
				24,
				color(255),
				null,
				color(40),
				3
			);
			this.addChild(gogglesLevelLabel);

			const glovesLevelLabel = new SJ.Label(
				this.getItemLevel('gloves'),
				parseInt(this.getItemLevel('skis')) > 99 ? x2 - 14 : x2,
				310,
				CENTER,
				CENTER,
				24,
				color(255),
				null,
				color(40),
				3
			);
			this.addChild(glovesLevelLabel);

			const bootsLevelLabel = new SJ.Label(
				this.getItemLevel('boots'),
				parseInt(this.getItemLevel('skis')) > 99 ? x2 - 14 : x2,
				410,
				CENTER,
				CENTER,
				24,
				color(255),
				null,
				color(40),
				3
			);
			this.addChild(bootsLevelLabel);

			const successfulJumpsLabel = new SJ.Label(
				successfulJumps,
				123,
				448,
				LEFT,
				CENTER,
				16,
				color(255),
				null,
				color(40),
				2
			);
			this.addChild(successfulJumpsLabel);

			const brokenMapRecordsLabel = new SJ.Label(
				brokenMapRecords,
				160,
				470,
				LEFT,
				CENTER,
				16,
				color(255),
				null,
				color(40),
				2
			);
			this.addChild(brokenMapRecordsLabel);

			const joinDateLabel = new SJ.Label(
				joinDate,
				272,
				467,
				CENTER,
				CENTER,
				16,
				color(255),
				null,
				color(40),
				2
			);
			this.addChild(joinDateLabel);
		}

		getItemLevel(itemName) {
			const item = this.equipmentData.filter((e) => {
				return e.item_id === itemName;
			})[0];

			if (item) return item.lvl;
		}
	};

	SJ.UserMedalsDisplay = class extends SJ.UI.Element {
		constructor(x, y, medalsData) {
			super(x, y);

			const fameGallerySS2 = SJ.fameGallerySS2;

			this.position = 'absolute';
			this.hide();

			const mainGraphic = new SJ.SpriteSheetTexture2(
				fameGallerySS2,
				0,
				0,
				null,
				null,
				443,
				369,
				342,
				375
			);
			this.addChild(mainGraphic);

			const medalsCount = [];

			medalsData.forEach((medal) => {
				medalsCount[medal.mapName] = medalsCount[medal.mapName]
					? medalsCount[medal.mapName] + 1
					: 1;
			});

			const markersX = 118;
			const markersYMultiplier = 53.5;
			const markersStartY = 44;

			const mostExpensiveMedalMapName =
				this.getMostExpensiveMedalMapName(medalsData);

			const szczyrkAwardedMedalsMarker = new SJ.mapAwardedMedalsDisplay(
				markersX,
				markersYMultiplier * 0 + markersStartY,
				medalsCount['Szczyrk'],
				mostExpensiveMedalMapName === 'Szczyrk' ? true : false
			);
			szczyrkAwardedMedalsMarker.workingName = 'szczyrk';
			this.addChild(szczyrkAwardedMedalsMarker);

			const oberstdorfAwardedMedalsMarker = new SJ.mapAwardedMedalsDisplay(
				markersX,
				markersYMultiplier * 1 + markersStartY,
				medalsCount['Oberstdorf'],
				mostExpensiveMedalMapName === 'Oberstdorf' ? true : false
			);
			this.addChild(oberstdorfAwardedMedalsMarker);

			const zakopaneAwardedMedalsMarker = new SJ.mapAwardedMedalsDisplay(
				markersX,
				markersYMultiplier * 2 + markersStartY,
				medalsCount['Zakopane'],
				mostExpensiveMedalMapName === 'Zakopane' ? true : false
			);
			this.addChild(zakopaneAwardedMedalsMarker);

			const vikersundAwardedMedalsMarker = new SJ.mapAwardedMedalsDisplay(
				markersX,
				markersYMultiplier * 3 + markersStartY,
				medalsCount['Vikersund'],
				mostExpensiveMedalMapName === 'Vikersund' ? true : false
			);
			this.addChild(vikersundAwardedMedalsMarker);

			const planicaAwardedMedalsMarker = new SJ.mapAwardedMedalsDisplay(
				markersX,
				markersYMultiplier * 4 + markersStartY,
				medalsCount['Planica'],
				mostExpensiveMedalMapName === 'Planica' ? true : false
			);
			this.addChild(planicaAwardedMedalsMarker);

			const pekinAwardedMedalsMarker = new SJ.mapAwardedMedalsDisplay(
				markersX,
				markersYMultiplier * 5 + markersStartY,
				medalsCount['Pekin 2030'],
				mostExpensiveMedalMapName === 'Pekin 2030' ? true : false
			);
			this.addChild(pekinAwardedMedalsMarker);
		}

		getMostExpensiveMedalMapName(medalsData) {
			let mostExpensiveMedal = medalsData[0];

			medalsData.forEach((medal) => {
				if (
					parseInt(medal.bonusMoney) > parseInt(mostExpensiveMedal.bonusMoney)
				)
					mostExpensiveMedal = medal;
			});

			return mostExpensiveMedal ? mostExpensiveMedal.mapName : null;
		}
	};

	SJ.mapAwardedMedalsDisplay = class extends SJ.UI.Element {
		constructor(x, y, medalsCount = 0, mostExpensiveMedal) {
			super(x, y);

			const fameGallerySS = SJ.fameGallerySS;

			const awardedMedalMarkersData = [
				{ x: 0, y: 88, w: 28, h: 34 },
				{ x: 230, y: 88, w: 27, h: 35 },
				{ x: 257, y: 88, w: 27, h: 35 },
				{ x: 284, y: 88, w: 27, h: 35 },
				{ x: 818, y: 88, w: 33, h: 39 },
			];

			const bestMedalMarkersData = [
				{ x: 828, y: 127, w: 37, h: 41 },
				{ x: 904, y: 127, w: 33, h: 42 },
				{ x: 0, y: 169, w: 34, h: 42 },
				{ x: 34, y: 169, w: 34, h: 42 },
				{ x: 68, y: 169, w: 40, h: 45 },
			];

			const markserXPos = [4, 45, 87, 128, 165];

			for (let i = 1; i <= 5; i++) {
				const marker = new SJ.SpriteSheetTexture2(
					fameGallerySS,
					markserXPos[i - 1],
					0,
					null,
					null,
					awardedMedalMarkersData[i - 1].x,
					awardedMedalMarkersData[i - 1].y,
					awardedMedalMarkersData[i - 1].w,
					awardedMedalMarkersData[i - 1].h
				);

				if (i > medalsCount) break;

				this.addChild(marker);
			}

			const childrenLast = this.children.length - 1;

			if (mostExpensiveMedal) {
				this.children[childrenLast].ssX = bestMedalMarkersData[childrenLast].x;
				this.children[childrenLast].ssY = bestMedalMarkersData[childrenLast].y;
				this.children[childrenLast].ssW = bestMedalMarkersData[childrenLast].w;
				this.children[childrenLast].ssH = bestMedalMarkersData[childrenLast].h;

				this.children[childrenLast].y -= 1;
			}
		}
	};

	SJ.UserBestJumpDisplay = class extends SJ.UI.Element {
		constructor(x, y, jumpData, inCareerTexture) {
			super(x, y);

			const fameGallerySS = SJ.fameGallerySS;
			const fameGallerySS2 = SJ.fameGallerySS2;

			this.position = 'absolute';
			super.hide();

			if (inCareerTexture) this.mainGraphic = inCareerTexture;
			else
				this.mainGraphic = new SJ.SpriteSheetTexture(
					fameGallerySS2,
					0,
					0,
					null,
					null,
					785,
					369,
					512,
					388
				);

			this.addChild(this.mainGraphic);

			const jumpParamLayout = new SJ.Layout(
				245,
				75.5,
				[
					new SJ.Label(
						`${jumpData.jumpDistance} M`,
						0,
						0,
						RIGHT,
						CENTER,
						14,
						color(255)
					),
					new SJ.Label(
						`${round(jumpData.maxHeight, 1)} M`,
						0,
						0,
						RIGHT,
						CENTER,
						14,
						color(255)
					),
					new SJ.Label(
						`${jumpData.jumpSpeed} KM/H`,
						0,
						0,
						RIGHT,
						CENTER,
						14,
						color(255),
						null
					),
					new SJ.Label(
						`${jumpData.jumpMoment} M`,
						0,
						0,
						RIGHT,
						CENTER,
						14,
						color(255)
					),
					new SJ.Label(
						`${jumpData.maxSpeed} KM/H`,
						0,
						0,
						RIGHT,
						CENTER,
						14,
						color(255)
					),
				],
				8,
				'column'
			);

			jumpParamLayout.verticalAlign = TOP;
			jumpParamLayout.horizontalAlign = RIGHT;

			this.addChild(jumpParamLayout);

			const landingAngleLabel = new SJ.Label(
				`${round(jumpData.landingAngle, 1)}°`,
				245,
				230,
				RIGHT,
				CENTER,
				14,
				color(255)
			);
			this.addChild(landingAngleLabel);

			const landingHeightLabel = new SJ.Label(
				`${jumpData.landingHeight} M`,
				245,
				265,
				RIGHT,
				CENTER,
				14,
				color(255)
			);
			this.addChild(landingHeightLabel);

			const weatherIconsData = {
				1: { x: 195, y: 88, w: 35, h: 35 },
				2: { x: 865, y: 127, w: 39, h: 42 },
				3: { x: 0, y: 55, w: 31, h: 30 },
				4: { x: 530, y: 55, w: 31, h: 31 },
				5: { x: 592, y: 55, w: 28, h: 32 },
				6: { x: 561, y: 55, w: 31, h: 31 },
			};

			if (jumpData.weatherStateIcon > 0) {
				const weatherConditionIcon = new SJ.SpriteSheetTexture(
					fameGallerySS,
					220,
					39,
					null,
					null,
					weatherIconsData[jumpData.weatherStateIcon].x,
					weatherIconsData[jumpData.weatherStateIcon].y,
					weatherIconsData[jumpData.weatherStateIcon].w,
					weatherIconsData[jumpData.weatherStateIcon].h
				);
				this.addChild(weatherConditionIcon);
			}

			const minWindSpeedLabel = new SJ.Label(
				`${jumpData.minWindSpeed} KM/H`,
				490,
				125,
				RIGHT,
				CENTER,
				14,
				color(255)
			);
			this.addChild(minWindSpeedLabel);

			const maxWindSpeedLabel = new SJ.Label(
				`${jumpData.maxWindSpeed} KM/H`,
				490,
				148,
				RIGHT,
				CENTER,
				14,
				color(255)
			);
			this.addChild(maxWindSpeedLabel);

			const weatherRatingIconsData = {
				0: { x: 89, y: 0, w: 85, h: 23 },
				1: { x: 174, y: 0, w: 85, h: 23 },
				2: { x: 259, y: 0, w: 85, h: 23 },
				3: { x: 344, y: 0, w: 85, h: 23 },
				4: { x: 429, y: 0, w: 85, h: 23 },
				5: { x: 514, y: 0, w: 85, h: 23 },
				6: { x: 599, y: 0, w: 85, h: 23 },
			};

			const weatherRatingIcon = new SJ.SpriteSheetTexture(
				fameGallerySS,
				205,
				80,
				null,
				null,
				weatherRatingIconsData[jumpData.weatherConditionRating].x,
				weatherRatingIconsData[jumpData.weatherConditionRating].y,
				weatherRatingIconsData[jumpData.weatherConditionRating].w,
				weatherRatingIconsData[jumpData.weatherConditionRating].h
			);
			this.addChild(weatherRatingIcon);

			const distanceScoreLabel = new SJ.Label(
				`${jumpData.jumpDistance} | ${jumpData.distanceScore} PKT`,
				490,
				224,
				RIGHT,
				CENTER,
				14,
				color(242, 197, 16)
			);
			this.addChild(distanceScoreLabel);

			const arbiterScoreLabel = new SJ.Label(
				`${jumpData.arbitersScore} PKT`,
				490,
				270,
				RIGHT,
				CENTER,
				14,
				color(255)
			);
			this.addChild(arbiterScoreLabel);

			const jumpScore = new SJ.Label(
				`${jumpData.jumpScore} PKT`,
				490,
				293,
				RIGHT,
				CENTER,
				14,
				color(242, 197, 16)
			);
			this.addChild(jumpScore);

			const arbiterRates = jumpData.arbitersRates
				.replaceAll('X', '')
				.split(';');

			const ratesY = 247;
			const ratesFontSize = 12;

			this.addChild(
				new SJ.Label(
					arbiterRates[0],
					292,
					ratesY,
					RIGHT,
					CENTER,
					ratesFontSize,
					color(255)
				)
			);
			this.addChild(
				new SJ.Label(
					arbiterRates[1],
					338,
					ratesY,
					RIGHT,
					CENTER,
					ratesFontSize,
					color(255)
				)
			);
			this.addChild(
				new SJ.Label(
					arbiterRates[2],
					382,
					ratesY,
					RIGHT,
					CENTER,
					ratesFontSize,
					color(255)
				)
			);
			this.addChild(
				new SJ.Label(
					arbiterRates[3],
					427,
					ratesY,
					RIGHT,
					CENTER,
					ratesFontSize,
					color(255)
				)
			);
			this.addChild(
				new SJ.Label(
					arbiterRates[4],
					471,
					ratesY,
					RIGHT,
					CENTER,
					ratesFontSize,
					color(255)
				)
			);

			const moneyGraphic = new SJ.SpriteSheetTexture2(
				fameGallerySS2,
				0,
				0,
				null,
				null,
				38,
				0,
				14,
				14
			);

			if (jumpData.medalName && jumpData.medalBonusMoney) {
				const medalNewspaperBackground = new SJ.SpriteSheetTexture(
					fameGallerySS2,
					17.5,
					140,
					null,
					null,
					612,
					257,
					443,
					112
				);
				this.addChild(medalNewspaperBackground);

				const medalGraphicsData = {
					Brązowy: { x: 31, y: 55, w: 171, h: 30 },
					Diamentowy: { x: 620, y: 55, w: 173, h: 32 },
					Kryształowy: { x: 619, y: 26, w: 171, h: 29 },
					Srebrny: { x: 448, y: 26, w: 171, h: 28 },
					Złoty: { x: 790, y: 26, w: 171, h: 29 },
				};

				const medalGraphic = new SJ.SpriteSheetTexture(
					fameGallerySS,
					27,
					76,
					null,
					null,
					medalGraphicsData[jumpData.medalName].x,
					medalGraphicsData[jumpData.medalName].y,
					medalGraphicsData[jumpData.medalName].w,
					medalGraphicsData[jumpData.medalName].h
				);

				const medalBonusMoneyLabel = new SJ.Label(
					`${jumpData.medalBonusMoney}`,
					0,
					0,
					LEFT,
					CENTER,
					15
				);
				const medalBonusMoneyLayout = new SJ.Layout(
					218,
					190,
					[medalBonusMoneyLabel, moneyGraphic],
					5,
					'row',
					RIGHT
				);

				let medalBonusGraphic;

				if (jumpData.wasVip === '1')
					medalBonusGraphic = new SJ.SpriteSheetTexture(
						fameGallerySS2,
						30,
						92,
						null,
						null,
						52,
						0,
						52,
						14
					);
				else
					medalBonusGraphic = new SJ.SpriteSheetTexture(
						fameGallerySS2,
						30,
						92,
						null,
						null,
						0,
						0,
						38,
						9
					);

				medalBonusGraphic.imageMode = CENTER;

				medalNewspaperBackground.addChild(medalBonusGraphic);
				medalNewspaperBackground.addChild(medalBonusMoneyLayout);
				medalNewspaperBackground.addChild(medalGraphic);
			}

			if (jumpData.newRank !== 'no rank' && jumpData.newRankBonusMoney > 0) {
				const rankNewspaperBackground = new SJ.SpriteSheetTexture(
					fameGallerySS2,
					17.5,
					140,
					null,
					null,
					1055,
					257,
					443,
					112
				);
				this.addChild(rankNewspaperBackground);

				const newRankGraphicsData = {
					Kadrowicz: { x: 28, y: 88, w: 167, h: 34 },
					Klubowicz: { x: 782, y: 0, w: 172, h: 26 },
					'Legenda Skoków': { x: 311, y: 88, w: 165, h: 35 },
					'Medalista Olimpijski': { x: 202, y: 55, w: 164, h: 30 },
					Medalista: { x: 250, y: 26, w: 166, h: 28 },
					'Mistrz Kraju': { x: 476, y: 88, w: 170, h: 35 },
					'Mistrz Świata': { x: 793, y: 55, w: 164, h: 33 },
					Młodzik: { x: 25, y: 26, w: 168, h: 26 },
					Olimpijczyk: { x: 366, y: 55, w: 164, h: 30 },
					Zawodowiec: { x: 646, y: 88, w: 172, h: 37 },
				};

				const newRankGraphic = new SJ.SpriteSheetTexture(
					fameGallerySS,
					26.5,
					101,
					null,
					null,
					newRankGraphicsData[jumpData.newRank].x,
					newRankGraphicsData[jumpData.newRank].y,
					newRankGraphicsData[jumpData.newRank].w,
					newRankGraphicsData[jumpData.newRank].h
				);

				const newRankBonusMoneyLabel = new SJ.Label(
					`${jumpData.newRankBonusMoney}`,
					40,
					60,
					LEFT,
					CENTER,
					15
				);
				const newRankBonusMoneyLayout = new SJ.Layout(
					218,
					238,
					[newRankBonusMoneyLabel, moneyGraphic],
					5,
					'row',
					RIGHT
				);

				let newRankBonusGraphic;

				if (jumpData.wasVip === '1')
					newRankBonusGraphic = new SJ.SpriteSheetTexture(
						fameGallerySS2,
						30,
						116,
						null,
						null,
						52,
						0,
						52,
						14
					);
				else
					newRankBonusGraphic = new SJ.SpriteSheetTexture(
						fameGallerySS2,
						30,
						116,
						null,
						null,
						0,
						0,
						38,
						9
					);

				newRankBonusGraphic.imageMode = CENTER;

				rankNewspaperBackground.addChild(newRankGraphic);
				rankNewspaperBackground.addChild(newRankBonusMoneyLayout);
				rankNewspaperBackground.addChild(newRankBonusGraphic);
			}

			if (jumpData.mapRecordBonusMoney > 0) {
				const recordNewspaperBackground = new SJ.SpriteSheetTexture(
					fameGallerySS2,
					17.5,
					140,
					null,
					null,
					1498,
					257,
					443,
					112
				);
				this.addChild(recordNewspaperBackground);

				const mapRecordGraphicsData = {
					Oberstdorf: { x: 0, y: 127, w: 138, h: 39 },
					'Pekin 2030': { x: 138, y: 127, w: 138, h: 39 },
					Planica: { x: 276, y: 127, w: 138, h: 39 },
					Szczyrk: { x: 414, y: 127, w: 138, h: 39 },
					Vikersund: { x: 552, y: 127, w: 138, h: 39 },
					Zakopane: { x: 690, y: 127, w: 138, h: 39 },
				};

				this.mapRecordGraphic = new SJ.SpriteSheetTexture(
					fameGallerySS,
					141,
					92,
					null,
					null,
					mapRecordGraphicsData[jumpData.mapName].x,
					mapRecordGraphicsData[jumpData.mapName].y,
					mapRecordGraphicsData[jumpData.mapName].w,
					mapRecordGraphicsData[jumpData.mapName].h
				);

				const mapRecordBonusMoneyLabel = new SJ.Label(
					`${jumpData.mapRecordBonusMoney}`,
					0,
					0,
					LEFT,
					CENTER,
					15
				);
				const mapRecordBonusMoneyLayout = new SJ.Layout(
					418,
					238,
					[mapRecordBonusMoneyLabel, moneyGraphic],
					5,
					'row',
					RIGHT
				);

				recordNewspaperBackground.addChild(this.mapRecordGraphic);
				recordNewspaperBackground.addChild(mapRecordBonusMoneyLayout);
			}

			super.hide();
		}
	};

	SJ.TournamentButton = class extends SJ.TextureButton {
		constructor(
			x,
			y,
			name,
			minRank,
			mapsArray,
			seriesCount,
			hoverTexture,
			disabledTexture,
			disabledHoverTexture
		) {
			super(
				x,
				y,
				null,
				null,
				hoverTexture,
				disabledTexture,
				disabledHoverTexture,
				'disabledTexture',
				() => {
					SJ._startTournament(name, mapsArray, seriesCount);
				}
			);

			this.hoverTexture.animation._loopMode = false;
			this.hoverTexture.animation._resetAtEnd = false;

			this.disabledHoverTextureTranslate = {
				x: 100,
				y: 55,
			};

			this.disabled = true;

			this.mapsLabelCaption = '';

			let mapsAlreadyAdded = 0;

			mapsArray.forEach((map) => {
				this.mapsLabelCaption += `${map}, `;

				mapsAlreadyAdded++;
				if (mapsAlreadyAdded > 2) {
					this.mapsLabelCaption += `\n`;
					mapsAlreadyAdded = 0;
				}
			});

			if (mapsAlreadyAdded === 0)
				this.mapsLabelCaption = this.mapsLabelCaption.slice(0, -1);

			this.mapsLabel = new SJ.Label(
				this.mapsLabelCaption.toUpperCase().slice(0, -2),
				278.1 / 2,
				105,
				CENTER,
				TOP,
				14
			);

			this.addChild(this.mapsLabel);

			fetch(
				`${SJ.APILink}tournaments/checkUserRank.php?userName=${SJ.playerData.data['name']}&tournamentName=${name}`
			)
				.then((res) => {
					return res.json();
				})
				.then((res) => {
					if (res === 'CORRECT') this.disabled = false;

					if (this.disabled) {
						this.mapsLabel.fontColor = color(150, 150, 150);
					}
				});
		}
	};

	SJ.CareerRankDisplay = class extends SJ.UI.Element {
		constructor(x, y, medalsCount, sprites, careerScreenSS) {
			super(x, y);

			if (medalsCount >= 3) {
				const rankImage = new SJ.SpriteSheetTexture2(
					careerScreenSS,
					0,
					0,
					null,
					null,
					sprites['image-3'].x,
					sprites['image-3'].y,
					sprites['image-3'].w,
					sprites['image-3'].h
				);
				this.addChild(rankImage);
			} else if (medalsCount === 2) {
				const rankImage = new SJ.SpriteSheetTexture2(
					careerScreenSS,
					0,
					0,
					null,
					null,
					sprites['image-2'].x,
					sprites['image-2'].y,
					sprites['image-2'].w,
					sprites['image-2'].h
				);
				this.addChild(rankImage);
			} else if (medalsCount === 1) {
				const rankImage = new SJ.SpriteSheetTexture2(
					careerScreenSS,
					0,
					0,
					null,
					null,
					sprites['image-1'].x,
					sprites['image-1'].y,
					sprites['image-1'].w,
					sprites['image-1'].h
				);
				this.addChild(rankImage);
			}
		}
	};

	SJ.CareerMedalsDisplay = class extends SJ.UI.Element {
		constructor(x, y, medalsData, mostExpensiveMedalId, careerScreenSS) {
			super(x, y);

			const medalsImage = [
				{
					graphic: new SJ.TextureButton(
						0,
						0,
						null,
						new SJ.SpriteSheetTexture2(
							careerScreenSS,
							0,
							0,
							null,
							null,
							166,
							47,
							41,
							49
						),
						null,
						null,
						null,
						null,
						null,
						null,
						null,
						null,
						null,
						0,
						0
					),
					highlight: new SJ.TextureButton(
						-6,
						-5,
						null,
						new SJ.SpriteSheetTexture2(
							careerScreenSS,
							0,
							0,
							null,
							null,
							377,
							98,
							51,
							60
						),
						null,
						null,
						null,
						null,
						null,
						null,
						null,
						null,
						null,
						0,
						0
					),
				},
				{
					graphic: new SJ.TextureButton(
						60,
						0,
						null,
						new SJ.SpriteSheetTexture(
							careerScreenSS,
							0,
							0,
							null,
							null,
							207,
							47,
							39,
							51
						),
						null,
						null,
						null,
						null,
						null,
						null,
						null,
						null,
						null,
						0,
						0
					),
					highlight: new SJ.TextureButton(
						55,
						-5,
						null,
						new SJ.SpriteSheetTexture(
							careerScreenSS,
							0,
							0,
							null,
							null,
							428,
							98,
							49,
							61
						),
						null,
						null,
						null,
						null,
						null,
						null,
						null,
						null,
						null,
						0,
						0
					),
				},
				{
					graphic: new SJ.TextureButton(
						119,
						0,
						null,
						new SJ.SpriteSheetTexture(
							careerScreenSS,
							0,
							0,
							null,
							null,
							686,
							47,
							39,
							51
						),
						null,
						null,
						null,
						null,
						null,
						null,
						null,
						null,
						null,
						0,
						0
					),
					highlight: new SJ.TextureButton(
						114,
						-5,
						null,
						new SJ.SpriteSheetTexture(
							careerScreenSS,
							0,
							0,
							null,
							null,
							525,
							98,
							49,
							61
						),
						null,
						null,
						null,
						null,
						null,
						null,
						null,
						null,
						null,
						0,
						0
					),
				},
				{
					graphic: new SJ.TextureButton(
						179,
						0,
						null,
						new SJ.SpriteSheetTexture(
							careerScreenSS,
							0,
							0,
							null,
							null,
							140,
							98,
							38,
							51
						),
						null,
						null,
						null,
						null,
						null,
						null,
						null,
						null,
						null,
						0,
						0
					),
					highlight: new SJ.TextureButton(
						174,
						-5,
						null,
						new SJ.SpriteSheetTexture(
							careerScreenSS,
							0,
							0,
							null,
							null,
							477,
							98,
							48,
							61
						),
						null,
						null,
						null,
						null,
						null,
						null,
						null,
						null,
						null,
						0,
						0
					),
				},
				{
					graphic: new SJ.TextureButton(
						233,
						0,
						null,
						new SJ.SpriteSheetTexture(
							careerScreenSS,
							0,
							0,
							null,
							null,
							329,
							98,
							48,
							56
						),
						null,
						null,
						null,
						null,
						null,
						null,
						null,
						null,
						null,
						0,
						0
					),
					highlight: new SJ.TextureButton(
						228,
						-5,
						null,
						new SJ.SpriteSheetTexture(
							careerScreenSS,
							0,
							0,
							null,
							null,
							574,
							98,
							58,
							66
						),
						null,
						null,
						null,
						null,
						null,
						null,
						null,
						null,
						null,
						0,
						0
					),
				},
			];

			let i = 0;

			medalsData.forEach((medal) => {
				const medalTexture = medalsImage[i].graphic;
				medalTexture.mouseMode = SJ.UI.MOUSE_MODE.TEST_AND_BLOCK;

				const medalInfo = new SJ.SpeechBubble(
					`${medal.medalName}: ${medal.bonusMoney} €`
				);
				medalInfo.hide();

				medalInfo.y = -95;

				medalTexture.onMouseEnter = () => {
					medalInfo.show();
				};

				medalTexture.onMouseLeave = () => {
					medalInfo.hide();
				};

				medalTexture.addChild(medalInfo);
				this.addChild(medalTexture);

				if (medal.id === mostExpensiveMedalId)
					this.addChild(medalsImage[i].highlight);

				i++;
			});
		}
	};

	SJ.UserCareerBestJumpsDisplay = class extends SJ.UI.Element {
		constructor(jumpData, careerScreenSS) {
			super(25, 100);

			this.position = 'absolute';

			const backgroundTexture = new SJ.Texture(
				'../sj-graphics/UI/career-screen/best-jumps-background.png',
				0,
				0
			);
			this.addChild(backgroundTexture);

			const closeBtn = new SJ.TextureButton(1490, 0, null, null);
			closeBtn.w = 51;
			closeBtn.h = 49;
			closeBtn.onMousePress = () => {
				this.hide();
			};

			this.addChild(closeBtn);

			let xi = 0;
			let yi = 0;

			const startX = 5;
			const startY = 15;

			const mapNames = [
				'Szczyrk',
				'Oberstdorf',
				'Zakopane',
				'Vikersund',
				'Planica',
				'Pekin 2030',
			];

			jumpData.forEach((data) => {
				data.record_id = mapNames.indexOf(data.mapName);
			});

			jumpData.sort((a, b) => {
				return a.record_id - b.record_id;
			});

			// console.log(jumpData);

			jumpData.forEach((data) => {
				let x = 515 * xi + startX;
				let y = 370 * yi + startY;

				const jumpParamDisplay = new SJ.UserBestJumpDisplay(
					x,
					y,
					data,
					new SJ.SpriteSheetTexture(
						careerScreenSS,
						0,
						0,
						null,
						null,
						512,
						1015,
						512,
						388
					)
				);

				jumpParamDisplay.position = 'relative';
				jumpParamDisplay.show();

				const mapRecordGraphicsData = {
					Oberstdorf: { x: 0, y: 0, w: 117, h: 39 },
					'Pekin 2030': { x: 117, y: 0, w: 117, h: 39 },
					Planica: { x: 234, y: 0, w: 117, h: 39 },
					Szczyrk: { x: 351, y: 0, w: 117, h: 39 },
					Vikersund: { x: 468, y: 0, w: 117, h: 39 },
					Zakopane: { x: 585, y: 0, w: 117, h: 39 },
				};

				if (jumpParamDisplay.mapRecordGraphic) {
					jumpParamDisplay.mapRecordGraphic = new SJ.SpriteSheetTexture(
						careerScreenSS,
						0,
						0,
						null,
						null,
						mapRecordGraphicsData[data.mapName].x,
						mapRecordGraphicsData[data.mapName].y,
						mapRecordGraphicsData[data.mapName].w,
						mapRecordGraphicsData[data.mapName].h
					);

					jumpParamDisplay.mapRecordGraphic.x += 20;
				}

				const mapNamesData = {
					Oberstdorf: { x: 246, y: 47, w: 168, h: 51 },
					'Pekin 2030': { x: 414, y: 47, w: 154, h: 51 },
					Planica: { x: 568, y: 47, w: 118, h: 51 },
					Szczyrk: { x: 725, y: 47, w: 124, h: 51 },
					Vikersund: { x: 849, y: 47, w: 148, h: 51 },
					Zakopane: { x: 0, y: 98, w: 140, h: 51 },
				};

				const mapName = new SJ.SpriteSheetTexture(
					careerScreenSS,
					(x + 260) / 2 - mapNamesData[data.mapName].w / 4,
					(y + 40) / 2 - mapNamesData[data.mapName].h / 4,
					null,
					null,
					mapNamesData[data.mapName].x,
					mapNamesData[data.mapName].y,
					mapNamesData[data.mapName].w,
					mapNamesData[data.mapName].h
				);

				const disabledTexture = new SJ.SpriteSheetTexture(
					careerScreenSS,
					x / 2,
					(y + 14) / 2,
					null,
					null,
					0,
					1015,
					512,
					331
				);

				if (data.jumpDistance !== '0') this.addChild(jumpParamDisplay);
				else this.addChild(disabledTexture);

				this.addChild(mapName);

				xi++;

				if (xi > 2) {
					xi = 0;
					yi++;
				}
			});

			this.hide();
		}
	};

	SJ.Settings = class extends SJ.UI.Element {
		constructor() {
			super(SJ.SCREEN_MIDDLE_X, SJ.SCREEN_MIDDLE_Y);

			this.mouseMode = SJ.UI.MOUSE_MODE.BLOCK;

			const settingsSS = SJ.ImageLoader.load(
				'../sj-graphics/UI/settings/settingsSS.png'
			);
			const bigSelectedTexture = new SJ.SpriteSheetTexture(
				settingsSS,
				0,
				0,
				null,
				null,
				180,
				0,
				136,
				47
			);
			const mediumSelectedTexture = new SJ.SpriteSheetTexture(
				settingsSS,
				0,
				0,
				null,
				null,
				92,
				0,
				88,
				47
			);
			const smallSelectedTexture = new SJ.SpriteSheetTexture(
				settingsSS,
				0,
				0,
				null,
				null,
				29,
				0,
				63,
				47
			);

			const mainGraphic = new SJ.SpriteSheetTexture(
				settingsSS,
				0,
				0,
				null,
				null,
				0,
				164,
				751,
				526,
				1,
				1
			);
			this.addChild(mainGraphic);

			this.x -= mainGraphic.w / 2;
			this.y -= mainGraphic.h / 2;

			this.w = mainGraphic.w;
			this.h = mainGraphic.h;

			// GS-graphic setting

			const graphicButtonsX = 65;

			this.ultraLowGS = new SJ.TextureButton(
				graphicButtonsX,
				113,
				null,
				null,
				bigSelectedTexture
			);
			this.ultraLowGS.onMousePress = () => {
				SJ.settings.graphic = 'ultralow';
				document.cookie = `graphicsSettings = ${SJ.settings.graphic}`;

				this.setActiveGraphicButton();
			};
			this.addChild(this.ultraLowGS);

			this.lowGS = new SJ.TextureButton(
				graphicButtonsX,
				155,
				null,
				null,
				bigSelectedTexture
			);
			this.lowGS.onMousePress = () => {
				SJ.settings.graphic = 'low';
				document.cookie = `graphicsSettings = ${SJ.settings.graphic}`;

				this.setActiveGraphicButton();
			};
			this.addChild(this.lowGS);

			this.mediumGS = new SJ.TextureButton(
				graphicButtonsX,
				197,
				null,
				null,
				bigSelectedTexture
			);
			this.mediumGS.onMousePress = () => {
				SJ.settings.graphic = 'medium';
				document.cookie = `graphicsSettings = ${SJ.settings.graphic}`;

				this.setActiveGraphicButton();
			};
			this.addChild(this.mediumGS);

			this.highGS = new SJ.TextureButton(
				graphicButtonsX,
				240,
				null,
				null,
				bigSelectedTexture
			);
			this.highGS.onMousePress = () => {
				SJ.settings.graphic = 'high';
				document.cookie = `graphicsSettings = ${SJ.settings.graphic}`;

				this.setActiveGraphicButton();
			};
			this.addChild(this.highGS);

			this.setActiveGraphicButton();

			this.lowFPSBtn = new SJ.TextureButton(
				117,
				405,
				null,
				null,
				mediumSelectedTexture
			);
			this.lowFPSBtn.onMousePress = () => {
				SJ.settings.framerate = 30;
				frameRate(30);

				this.lowFPSBtn.forceHoverTexure = true;
				this.highFPSBtn.forceHoverTexure = false;

				SJ.Tools.updateSettingInDatabase('fps', SJ.settings.framerate);
			};
			this.lowFPSBtn.forceHoverTexure = false;
			this.addChild(this.lowFPSBtn);

			this.highFPSBtn = new SJ.TextureButton(
				209,
				405,
				null,
				null,
				mediumSelectedTexture
			);
			this.highFPSBtn.onMousePress = () => {
				SJ.settings.framerate = 60;
				frameRate(60);

				this.lowFPSBtn.forceHoverTexure = false;
				this.highFPSBtn.forceHoverTexure = true;

				SJ.Tools.updateSettingInDatabase('fps', SJ.settings.framerate);
			};
			this.highFPSBtn.forceHoverTexure = false;
			this.addChild(this.highFPSBtn);

			if (SJ.settings.framerate === 60) {
				this.highFPSBtn.forceHoverTexure = true;
			} else {
				this.lowFPSBtn.forceHoverTexure = true;
			}

			this.languageOption = new SJ.SpriteSheetTexture(
				settingsSS,
				235,
				55,
				null,
				null,
				180,
				0,
				136,
				47
			);
			this.addChild(this.languageOption);

			this.futureLanguageTexture = new SJ.SpriteSheetTexture(
				settingsSS,
				237,
				79.5,
				null,
				null,
				316,
				0,
				187,
				164
			);
			this.addChild(this.futureLanguageTexture);

			this.menuSFXon = new SJ.TextureButton(
				434,
				416,
				null,
				null,
				smallSelectedTexture
			);
			this.menuSFXon.onMousePress = () => {
				this.menuSFXon.forceHoverTexure = true;
				this.menuSFXoff.forceHoverTexure = false;

				SJ.settings.menuSFX = true;
				SJ.Tools.updateSettingInDatabase('menuSFX', 1);

				SJ.mainMenuSoundContainer.unlockPlaying();
			};

			this.menuSFXoff = new SJ.TextureButton(
				491,
				416,
				null,
				null,
				smallSelectedTexture
			);
			this.menuSFXoff.onMousePress = () => {
				this.menuSFXon.forceHoverTexure = false;
				this.menuSFXoff.forceHoverTexure = true;

				SJ.settings.menuSFX = false;
				SJ.Tools.updateSettingInDatabase('menuSFX', 0);

				SJ.mainMenuSoundContainer.pause();
				SJ.mainMenuSoundContainer.lockPlaying();
			};

			if (SJ.settings.menuSFX) {
				this.menuSFXon.forceHoverTexure = true;
			} else {
				this.menuSFXoff.forceHoverTexure = true;
			}

			this.addChild(this.menuSFXon);
			this.addChild(this.menuSFXoff);

			this.SFXon = new SJ.TextureButton(
				434,
				462,
				null,
				null,
				smallSelectedTexture
			);
			this.SFXon.onMousePress = () => {
				this.SFXon.forceHoverTexure = true;
				this.SFXoff.forceHoverTexure = false;

				SJ.settings.SFX = true;
				SJ.Tools.updateSettingInDatabase('SFX', 1);

				SJ.SFXSoundManager.unlockPlaying();
			};

			this.SFXoff = new SJ.TextureButton(
				491,
				462,
				null,
				null,
				smallSelectedTexture
			);
			this.SFXoff.onMousePress = () => {
				this.SFXon.forceHoverTexure = false;
				this.SFXoff.forceHoverTexure = true;

				SJ.settings.SFX = false;
				SJ.Tools.updateSettingInDatabase('SFX', 0);

				SJ.SFXSoundManager.pause();
				SJ.SFXSoundManager.lockPlaying();
			};

			// 416

			if (SJ.settings.SFX) {
				this.SFXon.forceHoverTexure = true;
			} else {
				this.SFXoff.forceHoverTexure = true;
			}

			this.addChild(this.SFXon);
			this.addChild(this.SFXoff);

			this.musicOn = new SJ.TextureButton(
				434,
				370,
				null,
				null,
				smallSelectedTexture
			);
			this.musicOn.onMousePress = () => {
				this.musicOn.forceHoverTexure = true;
				this.musicOff.forceHoverTexure = false;

				SJ.settings.music = true;
				SJ.Tools.updateSettingInDatabase('music', 1);
				SJ.mainSoundtrack.play();
			};

			this.musicOff = new SJ.TextureButton(
				491,
				370,
				null,
				null,
				smallSelectedTexture
			);
			this.musicOff.onMousePress = () => {
				this.musicOn.forceHoverTexure = false;
				this.musicOff.forceHoverTexure = true;

				SJ.settings.music = false;
				SJ.Tools.updateSettingInDatabase('music', 0);
				SJ.mainSoundtrack.pause();
			};

			if (SJ.settings.music) this.musicOn.forceHoverTexure = true;
			else this.musicOff.forceHoverTexure = true;

			this.addChild(this.musicOn);
			this.addChild(this.musicOff);

			this.bajzelBtn = new SJ.TextureButton(
				624,
				380,
				null,
				null
			);
			this.bajzelBtn.w = 72;
			this.bajzelBtn.h = 24;
			this.bajzelBtn.mouseMode = SJ.UI.MOUSE_MODE.TEST_AND_BLOCK;
			this.bajzelBtn.onMousePress = () => window.open('https://portalmmo.pl/aktualnosci/bajzel-amba-na-premierowej-plycie-game-over-z-muzyka-dla-gry-ski-jumps-simulator-wywiad,715.html', '_blank');;
			this.bajzelBtn.workingName = 'bajzelBtn';
			this.addChild(this.bajzelBtn);

			this.closeBtn = new SJ.TextureButton(
				710,
				24,
				null,
				new SJ.SpriteSheetTexture(settingsSS, 0, 0, null, null, 0, 0, 29, 28)
			);
			this.closeBtn.onMousePress = () => this.hide();
			this.addChild(this.closeBtn);

			this.hide();
		}

		setGraphicButtonsNonactive() {
			this.ultraLowGS.forceHoverTexure = false;
			this.lowGS.forceHoverTexure = false;
			this.mediumGS.forceHoverTexure = false;
			this.highGS.forceHoverTexure = false;
		}

		setActiveGraphicButton() {
			this.setGraphicButtonsNonactive();

			if (SJ.settings.graphic === 'ultralow')
				this.ultraLowGS.forceHoverTexure = true;
			else if (SJ.settings.graphic === 'low')
				this.lowGS.forceHoverTexure = true;
			else if (SJ.settings.graphic === 'medium')
				this.mediumGS.forceHoverTexure = true;
			else if (SJ.settings.graphic === 'high')
				this.highGS.forceHoverTexure = true;

			SJ.Tools.updateSettingInDatabase('graphic', SJ.settings.graphic);
		}

		update() {
			if (SJ.settings.music) {
				this.musicOn.forceHoverTexure = true;
				this.musicOff.forceHoverTexure = false;
			} else {
				this.musicOn.forceHoverTexure = false;
				this.musicOff.forceHoverTexure = true;
			}
		}

		show() {
			this.update();
			super.show();
		}
	};

	SJ.RegisterForm = class extends SJ.UI.Element {
		constructor(registrationSS) {
			super();

			// Template contains logo, section title and input labels
			const registerTemplate = new SJ.SpriteSheetTexture(
				registrationSS,
				11.5,
				0.5,
				null,
				null,
				370,
				441,
				400,
				531
			);
			this.addChild(registerTemplate);

			const agreementChecked = new SJ.SpriteSheetTexture(
				registrationSS,
				51,
				246.5,
				null,
				null,
				0,
				0,
				10,
				10
			);
			agreementChecked.mouseMode = SJ.UI.MOUSE_MODE.PASS;
			agreementChecked.hide();

			this.agreementLabel = new SJ.TextureButton(
				98,
				487,
				null,
				new SJ.SpriteSheetTexture(
					registrationSS,
					0,
					0,
					null,
					null,
					1371,
					0,
					240,
					23
				),
				null,
				new SJ.SpriteSheetTexture(
					registrationSS,
					0,
					0,
					null,
					null,
					1371,
					0,
					240,
					23
				),
				null,
				null,
				function () {
					agreementChecked.hide();
					this.disabled = true;
				},
				null,
				null,
				null,
				true,
				0,
				0
			);

			this.agreementLabel.onDisabledMousePress = function () {
				agreementChecked.show();
				this.disabled = false;
			};
			this.agreementLabel.mouseMode = SJ.UI.MOUSE_MODE.TEST_AND_BLOCK;

			this.agreementRulesLink = new SJ.TextureButton(
				266,
				487,
				null,
				null,
				null,
				null,
				null,
				null,
				function () {
					window
						.open('https://skijumpsimulator.com/regulamin/', '_blank')
						.focus();
				},
				null,
				null,
				null,
				false,
				0,
				0
			);
			this.agreementRulesLink.w = 50;
			this.agreementRulesLink.h = 10;

			this.agreementPrivPolLink = new SJ.TextureButton(
				166,
				500,
				null,
				null,
				null,
				null,
				null,
				null,
				function () {
					window
						.open(
							'https://skijumpsimulator.com/polityka-prywatnosci/',
							'_blank'
						)
						.focus();
				},
				null,
				null,
				null,
				false,
				0,
				0
			);
			this.agreementPrivPolLink.w = 160;
			this.agreementPrivPolLink.h = 10;

			this.addChild(this.agreementLabel);
			this.addChild(agreementChecked);
			this.addChild(this.agreementRulesLink);
			this.addChild(this.agreementPrivPolLink);

			const registerButton = new SJ.TextureButton(
				77,
				407,
				null,
				new SJ.SpriteSheetTexture(
					registrationSS,
					0,
					0,
					null,
					null,
					1446,
					28,
					291,
					62
				),
				null,
				null,
				null,
				null,
				() => {
					fbq('track', 'SubmitApplication', { currency: 'PLN', value: 0.3 });
					if (this.validate()) SJ.registration.register();
				},
				null,
				null,
				null,
				null,
				0,
				0
			);
			this.addChild(registerButton);

			const playDemoLabel = new SJ.TextureButton(
				89,
				463,
				null,
				new SJ.SpriteSheetTexture(
					registrationSS,
					0,
					0,
					null,
					null,
					858,
					0,
					267,
					17
				),
				null,
				null,
				null,
				null,
				() => {
					fbq('track', 'StartTrial', { currency: 'PLN', value: 0.2 });
					SJ.registration.hide();
					SJ.demoTutorial.show();
				},
				null,
				null,
				null,
				null,
				0,
				0
			);
			this.addChild(playDemoLabel);
		}

		validate = () => {
			if (this.loginField.value().length < 3) {
				SJ.registration.validationErrors.loginError.show();
				return false;
			} else SJ.registration.validationErrors.loginError.hide();

			if (this.passwdField.value().length < 5) {
				SJ.registration.validationErrors.passwdError.show();
				return false;
			} else SJ.registration.validationErrors.passwdError.hide();

			if (!SJ.registration.validateEmail(this.emailField.value())) {
				SJ.registration.validationErrors.EmailError.show();
				return false;
			} else SJ.registration.validationErrors.EmailError.hide();

			if (this.agreementLabel.disabled) {
				SJ.registration.validationErrors.AgreementError.show();
				return false;
			} else SJ.registration.validationErrors.AgreementError.hide();

			return true;
		};
	};

	SJ.RegisterConfirmation = class extends SJ.UI.Element {
		constructor(registrationSS) {
			super();

			// Template contains logo, section title and input labels
			const registerConfirmationTemplate = new SJ.SpriteSheetTexture(
				registrationSS,
				257,
				95,
				null,
				null,
				770,
				441,
				568,
				536
			);
			this.addChild(registerConfirmationTemplate);

			const registerConfirmationButton = new SJ.TextureButton(
				654,
				546,
				null,
				new SJ.SpriteSheetTexture(
					registrationSS,
					0,
					0,
					null,
					null,
					0,
					90,
					291,
					62
				),
				null,
				null,
				null,
				null,
				() => {
					fbq('track', 'CompleteRegistration', {
						currency: 'PLN',
						value: 0.4,
					});
					location = window.location.origin + '/game';
				},
				null,
				null,
				null,
				null,
				0,
				0
			);
			this.addChild(registerConfirmationButton);

			this.hide();
		}
	};

	SJ.FacebookButton = class extends SJ.UI.Element {
		constructor(registrationSS) {
			super();

			const facebookButton = new SJ.TextureButton(
				83,
				534,
				null,
				new SJ.SpriteSheetTexture(
					registrationSS,
					0,
					0,
					null,
					null,
					0,
					28,
					282,
					49
				),
				null,
				null,
				null,
				null,
				() => {
					fbq('track', 'SubmitApplication', { currency: 'PLN', value: 0.3 });
					this.fb_login();
				},
				null,
				null,
				null,
				null,
				0,
				0
			);
			this.addChild(facebookButton);
		}

		fb_login = () => {
			FB.login((response) => {
				if (response.status === 'connected') {
					FB.api('/me', { fields: 'name, email' }, function (response) {
						fetch(`${SJ.APILink}user/register.php`, {
							method: 'POST',
							headers: { 'Content-Type': 'application/json' },
							body: JSON.stringify({
								login: response.name,
								passwd: response.name,
								email: response.email,
								isMobile: SJ.IS_MOBILE,
							}),
						})
							.then((res) => res.json())
							.then((data) => {
								if (data.type !== 'error') {
									fbq('track', 'CompleteRegistration', {
										currency: 'PLN',
										value: 0.4,
									});

									window.sessionStorage.setItem('playername', response.name);
									window.sessionStorage.setItem('playerpassword', response.name);

									if (window.sessionStorage.getItem('playername'))
										window.location = 'https://skijumpsimulator.com/game/';
								} else if (data.code === '001' || data.code === '002') {
									window.sessionStorage.setItem('playername', response.name);
									window.sessionStorage.setItem('playerpassword', response.name);

									if (window.sessionStorage.getItem('playername'))
										window.location = 'https://skijumpsimulator.com/game/';
								} else {
									console.log(data.message);
									window.sessionStorage.clear();
									window.localStorage.clear();
								}
							})
							.catch((e) => {
								console.log(e);
								window.sessionStorage.clear();
								window.localStorage.clear();
							});
					});
				}
			}, {
				scope: 'public_profile, email',
			});
		};
	};

	SJ.LoginForm = class extends SJ.UI.Element {
		constructor(registrationSS) {
			super();

			// Template contains section title, input labels and background image
			const loginTemplate = new SJ.SpriteSheetTexture(
				registrationSS,
				18.5,
				293,
				null,
				null,
				325,
				155,
				370,
				286
			);
			this.addChild(loginTemplate);

			const goToRecovery = new SJ.TextureButton(
				139,
				844,
				null,
				new SJ.SpriteSheetTexture(
					registrationSS,
					0,
					0,
					null,
					null,
					10,
					0,
					168,
					11
				),
				null,
				null,
				null,
				null,
				() => SJ.registration.recoveryForm.show(),
				null,
				null,
				null,
				null,
				0,
				0
			);
			this.addChild(goToRecovery);

			const loginButton = new SJ.TextureButton(
				77,
				781,
				null,
				new SJ.SpriteSheetTexture(
					registrationSS,
					0,
					0,
					null,
					null,
					573,
					28,
					291,
					62
				),
				null,
				null,
				null,
				null,
				() => {
					if (this.validate()) SJ.registration.login();
				},
				null,
				null,
				null,
				null,
				0,
				0
			);
			this.addChild(loginButton);
		}

		validate = () => {
			if (!this.loginField.value() || !this.passwdField.value()) {
				SJ.registration.validationErrors.LoginFormError.show();
				return false;
			} else SJ.registration.validationErrors.LoginFormError.hide();

			return true;
		};

		show() {
			SJ.registration.recoveryForm.hide();
			SJ.registration.recoveryConfirmation.hide();
			SJ.registration.passwdChangeForm.hide();
			SJ.registration.passwdChangeConfirmation.hide();

			SJ.registration.recoveryForm.emailField.hide();
			SJ.registration.passwdChangeForm.passwdField.hide();
			SJ.registration.passwdChangeForm.passwdFieldRep.hide();

			this.loginField.show();
			this.passwdField.show();

			SJ.registration.validationErrors.LoginFormError.hide();

			this.isVisible = true;
		}
	};

	SJ.RecoveryForm = class extends SJ.UI.Element {
		constructor(registrationSS) {
			super();

			// Template contains section title, input label and background image
			const recoveryTemplate = new SJ.SpriteSheetTexture(
				registrationSS,
				18.5,
				293,
				null,
				null,
				0,
				441,
				370,
				286
			);
			this.addChild(recoveryTemplate);

			const backButton = new SJ.TextureButton(
				374,
				593,
				null,
				new SJ.SpriteSheetTexture(
					registrationSS,
					0,
					0,
					null,
					null,
					1611,
					0,
					26,
					27
				),
				null,
				null,
				null,
				null,
				() => SJ.registration.loginForm.show(),
				null,
				null,
				null,
				null,
				0,
				0
			);
			this.addChild(backButton);

			const recoveryButton = new SJ.TextureButton(
				78,
				790,
				null,
				new SJ.SpriteSheetTexture(
					registrationSS,
					0,
					0,
					null,
					null,
					1155,
					28,
					291,
					62
				),
				null,
				null,
				null,
				null,
				() => {
					if (this.validate()) SJ.registration.getRecoveryToken();
				},
				null,
				null,
				null,
				null,
				0,
				0
			);
			this.addChild(recoveryButton);

			this.error = new SJ.SpriteSheetTexture(
				registrationSS,
				51,
				387.5,
				null,
				null,
				1125,
				0,
				246,
				17
			);
			this.error.hide();
			this.addChild(this.error);

			this.hide();
		}

		validate = () => {
			if (!SJ.registration.validateEmail(this.emailField.value())) {
				this.error.show();
				return false;
			} else this.error.hide();

			return true;
		};

		show() {
			SJ.registration.loginForm.hide();
			SJ.registration.recoveryConfirmation.hide();
			SJ.registration.passwdChangeForm.hide();
			SJ.registration.passwdChangeConfirmation.hide();

			SJ.registration.loginForm.loginField.hide();
			SJ.registration.loginForm.passwdField.hide();
			SJ.registration.passwdChangeForm.passwdField.hide();
			SJ.registration.passwdChangeForm.passwdFieldRep.hide();

			SJ.registration.validationErrors.LoginFormError.hide();

			this.emailField.show();

			this.isVisible = true;
		}
	};

	SJ.RecoveryConfirmation = class extends SJ.UI.Element {
		constructor(registrationSS) {
			super();

			// Template contains section title, input label and background image
			const recoveryConfirmationTemplate = new SJ.SpriteSheetTexture(
				registrationSS,
				18.5,
				293,
				null,
				null,
				1435,
				155,
				370,
				286
			);
			this.addChild(recoveryConfirmationTemplate);

			const confirmationButton = new SJ.TextureButton(
				78,
				790,
				null,
				new SJ.SpriteSheetTexture(
					registrationSS,
					0,
					0,
					null,
					null,
					282,
					28,
					291,
					62
				),
				null,
				null,
				null,
				null,
				() => {
					SJ.registration.loginForm.show();
				},
				null,
				null,
				null,
				null,
				0,
				0
			);
			this.addChild(confirmationButton);

			// this.hide();
		}

		show() {
			SJ.registration.loginForm.hide();
			SJ.registration.recoveryForm.hide();
			SJ.registration.passwdChangeForm.hide();
			SJ.registration.passwdChangeConfirmation.hide();

			SJ.registration.recoveryForm.emailField.hide();

			this.isVisible = true;
		}
	};

	SJ.PasswdChangeForm = class extends SJ.UI.Element {
		constructor(registrationSS) {
			super();

			// Template contains section title, input labels and background image
			const recoveryTemplate = new SJ.SpriteSheetTexture(
				registrationSS,
				18.5,
				293,
				null,
				null,
				1065,
				155,
				370,
				286
			);
			this.addChild(recoveryTemplate);

			const backButton = new SJ.TextureButton(
				374,
				593,
				null,
				new SJ.SpriteSheetTexture(
					registrationSS,
					0,
					0,
					null,
					null,
					1611,
					0,
					26,
					27
				),
				null,
				null,
				null,
				null,
				() => SJ.registration.loginForm.show(),
				null,
				null,
				null,
				null,
				0,
				0
			);
			this.addChild(backButton);

			const recoveryButton = new SJ.TextureButton(
				78,
				790,
				null,
				new SJ.SpriteSheetTexture(
					registrationSS,
					0,
					0,
					null,
					null,
					864,
					28,
					291,
					62
				),
				null,
				null,
				null,
				null,
				() => {
					if (this.validate()) SJ.registration.changePasswd();
				},
				null,
				null,
				null,
				null,
				0,
				0
			);
			this.addChild(recoveryButton);

			this.error = new SJ.SpriteSheetTexture2(
				registrationSS,
				87,
				773,
				null,
				null,
				590,
				0,
				268,
				17
			);
			this.error.hide();
			this.addChild(this.error);

			this.error2 = new SJ.SpriteSheetTexture2(
				registrationSS,
				137,
				773,
				null,
				null,
				178,
				0,
				168,
				16
			);
			this.error2.hide();
			this.addChild(this.error2);

			this.error3 = new SJ.SpriteSheetTexture2(
				registrationSS,
				99,
				773,
				null,
				null,
				346,
				0,
				244,
				16
			);
			this.error3.hide();
			this.addChild(this.error3);

			this.hide();
		}

		validate = () => {
			if (
				this.passwdField.value().length < 5 ||
				this.passwdFieldRep.value().length < 5
			) {
				SJ.registration.passwdChangeForm.error2.hide();
				SJ.registration.passwdChangeForm.error3.hide();
				SJ.registration.passwdChangeForm.error.show();
				return false;
			} else if (this.passwdField.value() !== this.passwdFieldRep.value()) {
				SJ.registration.passwdChangeForm.error.hide();
				SJ.registration.passwdChangeForm.error3.hide();
				SJ.registration.passwdChangeForm.error2.show();
				return false;
			} else {
				SJ.registration.passwdChangeForm.error.hide();
				SJ.registration.passwdChangeForm.error2.hide();
				SJ.registration.passwdChangeForm.error3.hide();
			}

			return true;
		};

		show() {
			SJ.registration.loginForm.hide();
			SJ.registration.recoveryForm.hide();
			SJ.registration.recoveryConfirmation.hide();
			SJ.registration.passwdChangeConfirmation.hide();

			SJ.registration.loginForm.loginField.hide();
			SJ.registration.loginForm.passwdField.hide();
			SJ.registration.recoveryForm.emailField.hide();

			SJ.registration.validationErrors.LoginFormError.hide();

			this.passwdField.show();
			this.passwdFieldRep.show();

			this.isVisible = true;
		}
	};

	SJ.PasswdChangeConfirmation = class extends SJ.UI.Element {
		constructor(registrationSS) {
			super();

			// Template contains section title, confirmation message and background image
			const passwdChangeConfirmationTemplate = new SJ.SpriteSheetTexture(
				registrationSS,
				18.5,
				293,
				null,
				null,
				695,
				155,
				370,
				286
			);
			this.addChild(passwdChangeConfirmationTemplate);

			const confirmationButton = new SJ.TextureButton(
				78,
				790,
				null,
				new SJ.SpriteSheetTexture(
					registrationSS,
					0,
					0,
					null,
					null,
					282,
					28,
					291,
					62
				),
				null,
				null,
				null,
				null,
				() => SJ.registration.loginForm.show(),
				null,
				null,
				null,
				null,
				0,
				0
			);
			this.addChild(confirmationButton);

			this.hide();
		}

		show() {
			SJ.registration.loginForm.hide();
			SJ.registration.recoveryForm.hide();
			SJ.registration.recoveryConfirmation.hide();
			SJ.registration.passwdChangeForm.hide();

			SJ.registration.passwdChangeForm.passwdField.hide();
			SJ.registration.passwdChangeForm.passwdFieldRep.hide();

			this.isVisible = true;
		}
	};

	SJ.ValidationErrors = class extends SJ.UI.Element {
		constructor(registrationSS) {
			super();

			this.loginError = new SJ.SpriteSheetTexture(
				registrationSS,
				194.5,
				109,
				null,
				null,
				616,
				90,
				325,
				65
			);
			this.loginError.hide();
			this.addChild(this.loginError);

			this.passwdError = new SJ.SpriteSheetTexture(
				registrationSS,
				194.5,
				142.5,
				null,
				null,
				1266,
				90,
				325,
				65
			);
			this.passwdError.hide();
			this.addChild(this.passwdError);

			this.EmailError = new SJ.SpriteSheetTexture(
				registrationSS,
				194.5,
				176,
				null,
				null,
				0,
				155,
				325,
				113
			);
			this.EmailError.hide();
			this.addChild(this.EmailError);

			this.AgreementError = new SJ.SpriteSheetTexture(
				registrationSS,
				194.5,
				233.5,
				null,
				null,
				291,
				90,
				325,
				65
			);
			this.AgreementError.hide();
			this.addChild(this.AgreementError);

			this.LoginFormError = new SJ.SpriteSheetTexture(
				registrationSS,
				194.5,
				342,
				null,
				null,
				941,
				90,
				325,
				65
			);
			this.LoginFormError.hide();
			this.addChild(this.LoginFormError);
		}
	};

	SJ.Registration = class extends SJ.UI.Element {
		constructor() {
			super(0, 0, 1600, 900);

			const registrationSS = SJ.ImageLoader.load(
				'../sj-graphics/UI/registration/registerFormSS.png'
			);

			const registrationBackground = new SJ.SpriteSheetTexture(
				registrationSS,
				0,
				0,
				null,
				null,
				1338,
				441,
				446,
				900
			);
			registrationBackground.mouseMode = SJ.UI.MOUSE_MODE.BLOCK;
			this.addChild(registrationBackground);

			this.registerForm = new SJ.RegisterForm(registrationSS);
			this.addChild(this.registerForm);

			this.facebookButton = new SJ.FacebookButton(registrationSS);
			this.addChild(this.facebookButton);

			this.loginForm = new SJ.LoginForm(registrationSS);
			this.addChild(this.loginForm);

			this.recoveryForm = new SJ.RecoveryForm(registrationSS);
			this.addChild(this.recoveryForm);

			this.recoveryConfirmation = new SJ.RecoveryConfirmation(registrationSS);
			this.addChild(this.recoveryConfirmation);

			this.passwdChangeForm = new SJ.PasswdChangeForm(registrationSS);
			this.addChild(this.passwdChangeForm);

			this.passwdChangeConfirmation = new SJ.PasswdChangeConfirmation(
				registrationSS
			);
			this.addChild(this.passwdChangeConfirmation);

			this.registerConfirmation = new SJ.RegisterConfirmation(registrationSS);
			this.addChild(this.registerConfirmation);

			this.registerForm.loginField = this.createInputField(
				'Wpisz nazwę swojego skoczka',
				'text',
				0.2589,
				'registerForm_loginField'
			);
			this.registerForm.passwdField = this.createInputField(
				'Wpisz swoje hasło',
				'password',
				0.3322,
				'registerForm_passwdField'
			);
			this.registerForm.emailField = this.createInputField(
				'Wpisz swój adres e-mail',
				'email',
				0.40555,
				'registerForm_emailField'
			);

			this.loginForm.loginField = this.createInputField(
				'Wpisz nazwę swojego skoczka',
				'text',
				0.7433,
				'loginForm_loginField'
			);
			this.loginForm.passwdField = this.createInputField(
				'Wpisz swoje hasło',
				'password',
				0.8166,
				'loginForm_passwdField'
			);

			this.recoveryForm.emailField = this.createInputField(
				'Wpisz swój adres e-mail',
				'email',
				0.8155
			);

			this.passwdChangeForm.passwdField = this.createInputField(
				'Wpisz nowe hasło',
				'password',
				0.7433
			);
			this.passwdChangeForm.passwdFieldRep = this.createInputField(
				'Powtórz nowe hasło',
				'password',
				0.8166
			);

			window.addEventListener('resize', () => {
				this.registerForm.loginField.updateStyles(0.2589);
				this.registerForm.passwdField.updateStyles(0.3322);
				this.registerForm.emailField.updateStyles(0.40555);

				this.loginForm.loginField.updateStyles(0.7433);
				this.loginForm.passwdField.updateStyles(0.8166);

				this.recoveryForm.emailField.updateStyles(0.8155);

				this.passwdChangeForm.passwdField.updateStyles(0.7433);
				this.passwdChangeForm.passwdFieldRep.updateStyles(0.8166);
			});

			this.validationErrors = new SJ.ValidationErrors(registrationSS);
			this.addChild(this.validationErrors);

			this.jumpsCountActivator = new SJ.TextureButton(
				266,
				18,
				null,
				null,
				null,
				null,
				null,
				null,
				null,
				null,
				() => this.jumpsCountSpeechBubble.show(),
				() => this.jumpsCountSpeechBubble.hide(),
				null,
				0,
				0
			);
			this.jumpsCountActivator.w = 45;
			this.jumpsCountActivator.h = 48;
			this.addChild(this.jumpsCountActivator);

			this.jumpsCountSpeechBubble = new SJ.SpeechBubble(
				'Ilość pozostałych skoków \n rankingowych na dzisiaj',
				250,
				75
			);
			this.addChild(this.jumpsCountSpeechBubble);

			this.guide = new SJ.Texture('UI/registration/poradnik.png', 1387, 653);

			this.guide.button = new SJ.TextureButton(0, 0, null, null);
			this.guide.button.w = 160;
			this.guide.button.h = 210;
			this.guide.button.widthOffset = 0;
			this.guide.button.heightOffset = 0;
			this.guide.button.mouseMode = SJ.UI.MOUSE_MODE.TEST_AND_BLOCK;
			this.guide.button.onMousePress = () => {
				fbq('track', 'ViewContent', { currency: 'PLN', value: 0.1 });

				window
					.open(
						'https://portalmmo.pl/aktualnosci/jak-zostac-skoczkiem-multimedialny-poradnik-ski-jump-simulator,720.html',
						'_blank'
					)
					.focus();
			};
			this.guide.addChild(this.guide.button);
			this.addChild(this.guide);

			this.mouseMode = SJ.UI.MOUSE_MODE.TEST_AND_BLOCK;
			this.hide();
		}

		register = () => {
			fetch(`${SJ.APILink}user/register.php`, {
				method: 'POST',
				headers: { 'Content-Type': 'application/json' },
				body: JSON.stringify({
					login: this.registerForm.loginField.value(),
					passwd: this.registerForm.passwdField.value(),
					email: this.registerForm.emailField.value(),
					isMobile: SJ.IS_MOBILE,
				}),
			})
				.then((res) => res.json())
				.then((data) => {
					if (data.type === 'error') {
						if (data.code === '001') {
							this.validationErrors.loginError.show();
						} else if (data.code === '002') {
							this.validationErrors.loginError.show();
						} else if (data.code === '003') console.log(data.message);
						else if (data.code === '004') console.log(data.message);
					} else {
						sessionStorage.setItem(
							'playername',
							this.registerForm.loginField.value()
						);
						sessionStorage.setItem(
							'playerpassword',
							this.registerForm.passwdField.value()
						);

						if (SJ.registrationTutorial.isVisible)
							SJ.registrationTutorial.hide();
						this.registerConfirmation.show();
					}
				})
				.catch((e) => console.log(e));
		};

		login = () => {
			fetch(`${SJ.APILink}user/login.php`, {
				method: 'POST',
				headers: { 'Content-Type': 'application/json' },
				body: JSON.stringify({
					login: this.loginForm.loginField.value(),
					passwd: this.loginForm.passwdField.value(),
				}),
			})
				.then((res) => res.json())
				.then((data) => {
					if (data.type === 'error') {
						if (data.code === '001') {
							this.validationErrors.LoginFormError.show();
						} else if (data.code === '002') console.log(data.message);
					} else {
						sessionStorage.setItem(
							'playername',
							this.loginForm.loginField.value()
						);
						sessionStorage.setItem(
							'playerpassword',
							this.loginForm.passwdField.value()
						);

						location = window.location.origin + '/game';
					}
				})
				.catch((e) => console.log(e));
		};

		getRecoveryToken = () => {
			fetch(`${SJ.APILink}user/recovery.php`, {
				method: 'POST',
				headers: { 'Content-Type': 'application/json' },
				body: JSON.stringify({
					email: this.recoveryForm.emailField.value(),
				}),
			})
				.then((res) => res.json())
				.then((data) => {
					if (data.type === 'error') {
						if (data.code === '001') {
							this.recoveryForm.error.show();
						} else if (data.code === '002') console.log(data.message);
					} else {
						this.recoveryConfirmation.show();
					}
				})
				.catch((e) => console.log(e));
		};

		changePasswd = () => {
			const queryString = window.location.search;
			const urlParams = new URLSearchParams(queryString);
			const tkn = urlParams.get('tkn');

			fetch(`${SJ.APILink}user/changePasswd.php`, {
				method: 'POST',
				headers: { 'Content-Type': 'application/json' },
				body: JSON.stringify({
					passwd: this.passwdChangeForm.passwdField.value(),
					tkn: tkn,
				}),
			})
				.then((res) => res.json())
				.then((data) => {
					if (data.type === 'error') {
						this.passwdChangeForm.error.hide();
						this.passwdChangeForm.error2.hide();
						this.passwdChangeForm.error3.show();
					} else SJ.registration.passwdChangeConfirmation.show();
				})
				.catch((e) => console.log(e));
		};

		validateEmail = (email) => {
			return String(email)
				.toLowerCase()
				.match(
					/^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
				);
		};

		createInputField = (value, type, topMultipler, name = null) => {
			const canvas = document.querySelector('#defaultCanvas0');

			const InputField = createInput();
			InputField.style('position', 'absolute');
			InputField.style('font-family', 'Aileron');
			InputField.style('font-weight', '500');
			InputField.style('color', '#9a9a9a');

			InputField.attribute('placeholder', value);
			InputField.attribute('type', type);
			if (name) InputField.attribute('id', name);
			InputField.attribute('name', name);
			InputField.attribute('autocomplete', 'on');

			InputField.updateStyles = (topMultipler) => {
				InputField.style(
					'width',
					`${Math.floor(canvas.clientWidth * 0.1875)}px`
				);
				InputField.style(
					'height',
					`${Math.floor(canvas.clientHeight * 0.041)}px`
				);
				InputField.style(
					'top',
					`${Math.floor(
						canvas.offsetTop + canvas.clientHeight * topMultipler
					)}px`
				);
				InputField.style(
					'left',
					`${Math.floor(canvas.offsetLeft + canvas.clientWidth * 0.044375)}px`
				);
				InputField.style(
					'padding',
					`0 ${Math.floor(canvas.clientWidth * 0.006875)}px`
				);
				InputField.style(
					'font-size',
					`${Math.ceil(canvas.clientWidth * 0.1875 * 0.04651)}px`
				);
				InputField.style(
					'border',
					`${Math.floor(canvas.clientWidth * 0.001875)}px solid #83c2ee`
				);
				InputField.style(
					'border-radius',
					`${Math.ceil(canvas.clientWidth * 0.0025)}px`
				);
			};

			InputField.show = () => InputField.style('display', `block`);

			InputField.hide = () => InputField.style('display', `none`);

			InputField.updateStyles(topMultipler);

			InputField.hide();

			return InputField;
		};

		show = (isPasswdChangeEnabled) => {
			this.isVisible = true;

			this.registerForm.loginField.show();
			this.registerForm.passwdField.show();
			this.registerForm.emailField.show();

			if (isPasswdChangeEnabled) {
				this.passwdChangeForm.show();
			} else {
				this.loginForm.show();
			}

			if (SJ.demoTutorial) SJ.demoTutorial.hide();
			if (SJ.registrationTutorial) SJ.registrationTutorial.show();
		};

		hide = () => {
			this.isVisible = false;

			this.registerForm.loginField.hide();
			this.registerForm.passwdField.hide();
			this.registerForm.emailField.hide();
			this.loginForm.loginField.hide();
			this.loginForm.passwdField.hide();
			this.recoveryForm.emailField.hide();
			this.passwdChangeForm.passwdField.hide();
			this.passwdChangeForm.passwdFieldRep.hide();

			if (SJ.registrationTutorial) SJ.registrationTutorial.hide();
		};
	};

	SJ.RegistrationTutorial = class extends SJ.UI.Element {
		constructor(guestTutorialsSS) {
			super();

			this.mobileAdjustmentInfo = new SJ.SpriteSheetTexture(
				guestTutorialsSS,
				562,
				6,
				null,
				null,
				673,
				0,
				465,
				385
			);
			this.addChild(this.mobileAdjustmentInfo);

			this.mobileAdjustmentInfo.backButton = new SJ.TextureButton(
				987,
				13,
				null,
				new SJ.SpriteSheetTexture(
					guestTutorialsSS,
					0,
					0,
					null,
					null,
					1138,
					0,
					37,
					40
				),
				null,
				null,
				null,
				null,
				() => this.mobileAdjustmentInfo.hide()
			);
			this.mobileAdjustmentInfo.addChild(this.mobileAdjustmentInfo.backButton);

			if (screen.availWidth >= screen.availHeight) {
				this.mobileAdjustmentInfo.hide();
			}

			window.addEventListener('resize', () => {
				if (screen.availWidth >= screen.availHeight)
					SJ.registrationTutorial.mobileAdjustmentInfo.hide();
				else SJ.registrationTutorial.mobileAdjustmentInfo.show();
			});

			this.startTutorial = new SJ.SpriteSheetTexture(
				guestTutorialsSS,
				236,
				284.5,
				null,
				null,
				1175,
				0,
				653,
				313
			);
			this.addChild(this.startTutorial);

			this.startTutorial.demoButton = new SJ.TextureButton(
				364,
				452.5,
				null,
				null,
				null,
				null,
				null,
				null,
				() => {
					fbq('track', 'StartTrial', { currency: 'PLN', value: 0.2 });
					SJ.registration.hide();
					SJ.demoTutorial.show();
				}
			);
			this.startTutorial.demoButton.w = 96;
			this.startTutorial.demoButton.h = 24;
			this.startTutorial.demoButton.onMouseEnter = () => {
				SJ.registration.mouseMode = SJ.UI.MOUSE_MODE.PASS;
			};
			this.startTutorial.demoButton.onMouseLeave = () => {
				SJ.registration.mouseMode = SJ.UI.MOUSE_MODE.TEST_AND_BLOCK;
			};
			this.startTutorial.addChild(this.startTutorial.demoButton);

			this.startTutorial.backButton = new SJ.TextureButton(
				691,
				300.5,
				null,
				null,
				null,
				null,
				null,
				null,
				() => {
					this.hide();
					this.startTutorial.backButton.onMouseLeave();
				}
			);
			this.startTutorial.backButton.w = 28;
			this.startTutorial.backButton.h = 25;
			this.startTutorial.backButton.onMouseEnter = () => {
				SJ.registration.mouseMode = SJ.UI.MOUSE_MODE.PASS;
			};
			this.startTutorial.backButton.onMouseLeave = () => {
				SJ.registration.mouseMode = SJ.UI.MOUSE_MODE.TEST_AND_BLOCK;
			};
			this.startTutorial.addChild(this.startTutorial.backButton);

			this.hide();
		}
	};

	SJ.DemoTutorial = class extends SJ.UI.Element {
		constructor(guestTutorialsSS) {
			super();

			this.demoTutorial = new SJ.SpriteSheetTexture(
				guestTutorialsSS,
				225,
				230,
				null,
				null,
				0,
				0,
				673,
				431
			);
			this.addChild(this.demoTutorial);

			this.demoTutorial.backButton = new SJ.TextureButton(
				690,
				255,
				null,
				null,
				null,
				null,
				null,
				null,
				() => this.hide()
			);
			this.demoTutorial.backButton.w = 28;
			this.demoTutorial.backButton.h = 25;
			this.demoTutorial.addChild(this.demoTutorial.backButton);

			this.hide();
		}
	};

	SJ.NewUserTutorial = class extends SJ.UI.Element {
		constructor(newspaperSS) {
			super();

			this.guideButton = new SJ.TextureButton(
				640,
				760,
				null,
				'UI/tutorial/poradnik-button.png'
			);
			this.guideButton.mouseMode = SJ.UI.MOUSE_MODE.TEST_AND_BLOCK;
			this.guideButton.onMousePress = () => {
				window
					.open(
						'https://portalmmo.pl/aktualnosci/jak-zostac-skoczkiem-multimedialny-poradnik-ski-jump-simulator,720.html',
						'_blank'
					)
					.focus();
			};
			this.addChild(this.guideButton);

			this.newspaper = new SJ.SpriteSheetTexture(
				newspaperSS,
				75,
				79.5,
				null,
				null,
				0,
				59,
				1332,
				630
			);
			this.newspaper.mouseMode = SJ.UI.MOUSE_MODE.TEST_AND_BLOCK;
			this.addChild(this.newspaper);

			this.backButton = new SJ.TextureButton(
				1442,
				280,
				null,
				null,
				null,
				null,
				null,
				null,
				() => this.hide(),
				null,
				null,
				null,
				null,
				0,
				0
			);
			this.backButton.w = 37;
			this.backButton.h = 39;
			this.addChild(this.backButton);

			this.backButton2 = new SJ.TextureButton(
				1102,
				631,
				null,
				null,
				null,
				null,
				null,
				null,
				() => this.hide(),
				null,
				null,
				null,
				null,
				0,
				0
			);
			this.backButton2.w = 242;
			this.backButton2.h = 10;
			this.addChild(this.backButton2);

			this.username = new SJ.Label(
				SJ.playerData.data['name'],
				445,
				535,
				CENTER,
				CENTER,
				18,
				'#fff',
				null,
				'#12b2f5',
				3
			);

			if (this.username.w > 200) {
				const fontSizeMultipler = 0.09 - (this.username.w - 200) / 1642;
				this.username.fontSize = Math.min(
					Math.max(Math.floor(this.username.w * fontSizeMultipler), 9),
					18
				);
			}

			this.addChild(this.username);

			const itemBoosts = {
				bindings: { x: 58, y: 0, w: 135, h: 55 },
				boots: { x: 193, y: 0, w: 135, h: 55 },
				gloves: { x: 328, y: 0, w: 135, h: 56 },
				goggles: { x: 463, y: 0, w: 135, h: 55 },
				helmet: { x: 598, y: 0, w: 135, h: 55 },
				skis: { x: 733, y: 0, w: 135, h: 55 },
				suit: { x: 868, y: 0, w: 156, h: 59 },
			};

			this.itemBoost = new SJ.SpriteSheetTexture(
				newspaperSS,
				0,
				0,
				null,
				null,
				itemBoosts[SJ.playerData.data.boostedItem].x,
				itemBoosts[SJ.playerData.data.boostedItem].y,
				itemBoosts[SJ.playerData.data.boostedItem].w,
				itemBoosts[SJ.playerData.data.boostedItem].h
			);

			if (SJ.playerData.data.boostedItem === 'suit') {
				this.itemBoost.x = 394.5;
				this.itemBoost.y = 347.5;
			} else {
				this.itemBoost.x = 398;
				this.itemBoost.y = 346.5;
			}

			this.addChild(this.itemBoost);

			this.checkMark1 = new SJ.SpriteSheetTexture(
				newspaperSS,
				695,
				182,
				null,
				null,
				0,
				0,
				21,
				22
			);
			this.checkMark1.hide();
			this.addChild(this.checkMark1);

			this.checkMark2 = new SJ.SpriteSheetTexture(
				newspaperSS,
				695,
				205,
				null,
				null,
				0,
				0,
				21,
				22
			);
			this.checkMark2.hide();
			this.addChild(this.checkMark2);

			this.checkMark3 = new SJ.SpriteSheetTexture(
				newspaperSS,
				695,
				224,
				null,
				null,
				0,
				0,
				21,
				22
			);
			this.checkMark3.hide();
			this.addChild(this.checkMark3);

			this.checkMark4 = new SJ.SpriteSheetTexture(
				newspaperSS,
				695,
				238,
				null,
				null,
				0,
				0,
				21,
				22
			);
			this.checkMark4.hide();
			this.addChild(this.checkMark4);

			this.checkMark5 = new SJ.SpriteSheetTexture(
				newspaperSS,
				695,
				251.5,
				null,
				null,
				0,
				0,
				21,
				22
			);
			this.checkMark5.hide();
			this.addChild(this.checkMark5);

			this.checkMark6 = new SJ.SpriteSheetTexture(
				newspaperSS,
				695,
				270,
				null,
				null,
				0,
				0,
				21,
				22
			);
			this.checkMark6.hide();
			this.addChild(this.checkMark6);

			this.goToTutorial = new SJ.TextureButton(
				1133,
				591,
				null,
				null,
				null,
				null,
				null,
				null,
				() => {
					this.hide();

					if (SJ.playerData.data['moneySpent'] < 50000) {
						SJ.tutorial1.show();
						SJ.tutorial1.closed = false;
					} else if (SJ.playerData.data['successfulJumps'] == 0) {
						SJ.tutorial2.show();
						SJ.tutorial2.closed = false;
					} else if (SJ.playerData.data['finishedTournaments'] == 0) {
						SJ.tutorial3.show();
						SJ.tutorial3.closed = false;
					} else if (SJ.playerData.data['successfulJumps'] < 25) {
						SJ.tutorial4.show();
						SJ.tutorial4.closed = false;
					} else if (SJ.playerData.data['VIPmoneySpent'] == 0) {
						SJ.tutorial5.show();
						SJ.tutorial5.closed = false;
					} else if (
						SJ.playerData.data['mapGlobalRankingScore'] < 750 ||
						SJ.playerData.data['tournamentRankingScore'] < 750
					) {
						SJ.tutorial6.show();
						SJ.tutorial6.closed = false;
					} else if (
						SJ.playerData.data['moneySpent'] >= 50000 &&
						SJ.playerData.data['successfulJumps'] > 0 &&
						SJ.playerData.data['finishedTournaments'] > 0 &&
						SJ.playerData.data['successfulJumps'] >= 25 &&
						SJ.playerData.data['VIPmoneySpent'] > 0 &&
						SJ.playerData.data['mapGlobalRankingScore'] >= 750 &&
						SJ.playerData.data['tournamentRankingScore'] >= 750
					) {
						SJ.tutorialEnd.show();
						SJ.tutorialEnd.closed = false;
					}
				}
			);
			this.goToTutorial.w = 182;
			this.addChild(this.goToTutorial);

			fetch(`${SJ.APILink}user/isJustCreated.php`, {
				method: 'POST',
				headers: { 'Content-Type': 'application/json' },
				body: JSON.stringify({
					name: SJ.playerData.data['name'],
				}),
			})
				.then((res) => res.json())
				.then((data) => {
					if (data.type === 'error') console.log(data.message);
					else if (data.message === 'false') this.hide();
				})
				.catch((e) => console.log(e));
		}

		show = () => {
			this.isVisible = true;

			if (SJ.playerData.data['moneySpent'] >= 50000) this.checkMark1.show();
			if (SJ.playerData.data['successfulJumps'] > 0) this.checkMark2.show();
			if (SJ.playerData.data['finishedTournaments'] > 0) this.checkMark3.show();
			if (SJ.playerData.data['successfulJumps'] >= 25) this.checkMark4.show();
			if (SJ.playerData.data['VIPmoneySpent'] > 0) this.checkMark5.show();
			if (
				SJ.playerData.data['mapGlobalRankingScore'] >= 750 &&
				SJ.playerData.data['tournamentRankingScore'] >= 750
			)
				this.checkMark6.show();

			if (SJ.playerData.data.isTutorialFinished)
				this.goToTutorial.disabled = true;
		};
	};

	SJ.Tutorial1 = class extends SJ.UI.Element {
		constructor(userTutorialsSS) {
			super();

			this.content = new SJ.SpriteSheetTexture(
				userTutorialsSS,
				225,
				275,
				null,
				null,
				0,
				0,
				670,
				339
			);
			this.content.mouseMode = SJ.UI.MOUSE_MODE.TEST_AND_BLOCK;
			this.addChild(this.content);

			this.content.backButton = new SJ.TextureButton(
				687,
				300,
				null,
				null,
				null,
				null,
				null,
				null,
				() => {
					this.hide();
					this.closed = true;
				}
			);
			this.content.backButton.w = 28;
			this.content.backButton.h = 25;
			this.content.addChild(this.content.backButton);

			this.closed = false;
			this.hide();
		}
	};

	SJ.Tutorial2 = class extends SJ.UI.Element {
		constructor(userTutorialsSS) {
			super();

			this.content = new SJ.SpriteSheetTexture(
				userTutorialsSS,
				225,
				225,
				null,
				null,
				0,
				440,
				688,
				445
			);
			this.content.mouseMode = SJ.UI.MOUSE_MODE.TEST_AND_BLOCK;
			this.addChild(this.content);

			this.content.backButton = new SJ.TextureButton(
				694,
				257,
				null,
				null,
				null,
				null,
				null,
				null,
				() => {
					this.hide();
					this.closed = true;
				}
			);
			this.content.backButton.w = 28;
			this.content.backButton.h = 25;
			this.content.addChild(this.content.backButton);

			this.closed = false;
			this.hide();
		}
	};

	SJ.Tutorial3 = class extends SJ.UI.Element {
		constructor(userTutorialsSS) {
			super();

			this.content = new SJ.SpriteSheetTexture(
				userTutorialsSS,
				225,
				225,
				null,
				null,
				1362,
				0,
				678,
				440
			);
			this.content.mouseMode = SJ.UI.MOUSE_MODE.TEST_AND_BLOCK;
			this.addChild(this.content);

			this.content.backButton = new SJ.TextureButton(
				685,
				253,
				null,
				null,
				null,
				null,
				null,
				null,
				() => {
					this.hide();
					this.closed = true;
				}
			);
			this.content.backButton.w = 28;
			this.content.backButton.h = 25;
			this.content.addChild(this.content.backButton);

			this.closed = false;
			this.hide();
		}
	};

	SJ.Tutorial4 = class extends SJ.UI.Element {
		constructor(userTutorialsSS) {
			super();

			this.content = new SJ.SpriteSheetTexture(
				userTutorialsSS,
				225,
				200,
				null,
				null,
				0,
				885,
				715,
				502
			);
			this.content.mouseMode = SJ.UI.MOUSE_MODE.TEST_AND_BLOCK;
			this.addChild(this.content);

			this.content.backButton = new SJ.TextureButton(
				735,
				225,
				null,
				null,
				null,
				null,
				null,
				null,
				() => {
					this.hide();
					this.closed = true;
				}
			);
			this.content.backButton.w = 28;
			this.content.backButton.h = 25;
			this.content.addChild(this.content.backButton);

			this.closed = false;
			this.hide();
		}
	};

	SJ.Tutorial5 = class extends SJ.UI.Element {
		constructor(userTutorialsSS) {
			super();

			this.content = new SJ.SpriteSheetTexture(
				userTutorialsSS,
				225,
				200,
				null,
				null,
				715,
				885,
				715,
				502
			);
			this.content.mouseMode = SJ.UI.MOUSE_MODE.TEST_AND_BLOCK;
			this.addChild(this.content);

			this.content.backButton = new SJ.TextureButton(
				735,
				225,
				null,
				null,
				null,
				null,
				null,
				null,
				() => {
					this.hide();
					this.closed = true;
				}
			);
			this.content.backButton.w = 28;
			this.content.backButton.h = 25;
			this.content.addChild(this.content.backButton);

			this.closed = false;
			this.hide();
		}
	};

	SJ.Tutorial6 = class extends SJ.UI.Element {
		constructor(userTutorialsSS) {
			super();

			this.content = new SJ.SpriteSheetTexture(
				userTutorialsSS,
				225,
				225,
				null,
				null,
				688,
				440,
				688,
				445
			);
			this.content.mouseMode = SJ.UI.MOUSE_MODE.TEST_AND_BLOCK;
			this.addChild(this.content);

			this.content.backButton = new SJ.TextureButton(
				694,
				258,
				null,
				null,
				null,
				null,
				null,
				null,
				() => {
					this.hide();
					this.closed = true;
				}
			);
			this.content.backButton.w = 28;
			this.content.backButton.h = 25;
			this.content.addChild(this.content.backButton);

			this.closed = false;
			this.hide();
		}
	};

	SJ.TutorialEnd = class extends SJ.UI.Element {
		constructor(userTutorialsSS) {
			super();

			this.content = new SJ.SpriteSheetTexture(
				userTutorialsSS,
				225,
				275,
				null,
				null,
				670,
				0,
				692,
				342
			);
			this.content.mouseMode = SJ.UI.MOUSE_MODE.TEST_AND_BLOCK;
			this.addChild(this.content);

			this.content.backButton = new SJ.TextureButton(
				698,
				303,
				null,
				null,
				null,
				null,
				null,
				null,
				() => {
					this.hide();
					this.closed = true;
				}
			);
			this.content.backButton.w = 28;
			this.content.backButton.h = 25;
			this.content.addChild(this.content.backButton);

			this.closed = false;
			this.hide();
		}

		show = () => {
			this.isVisible = true;

			if (!SJ.playerData.data.isTutorialFinished) {
				fetch(`${SJ.APILink}user/finishTutorial.php`, {
					method: 'POST',
					headers: { 'Content-Type': 'application/json' },
					body: JSON.stringify({
						name: SJ.playerData.data['name'],
					}),
				})
					.then((res) => res.json())
					.then((data) => {
						if (data.type === 'error') console.log(data.message);
						else {
							fbq('track', 'CustomizeProduct', {
								currency: 'PLN',
								value: 7.5,
							});

							SJ.playerData.data['isTutorialFinished'] = true;

							const timestamp = round(Date.now() / 1000);

							if (SJ.playerData.data['vipAccountExpirationTime'] === 0)
								SJ.playerData.data['vipAccountExpirationTime'] += timestamp;

							SJ.playerData.data['vipAccountExpirationTime'] += 7 * 86400;
							SJ.playerData.data['isVip'] = true;

							SJ.playerData.data['money'] += 50000;
							SJ.playerData.data['VIPmoney'] += 50;

							SJ.playerData.data[`worldcupDailyJumpsCount`] -= 10;
							SJ.playerData.data[`tournamentDailyJumpsCount`] -= 10;

							SJ.userDataBar.updateDisplayData();
							SJ.itemsManager.calculateImtesVariables();
						}
					})
					.catch((e) => console.log(e));
			}
		};
	};

	SJ.DailyBonus = class extends SJ.UI.Element {
		constructor() {
			super();

			const userDataBarSS = SJ.userDataBarSS;

			this.mainGraphic = new SJ.Texture('UI/premia-ok.png', 470, 400);
			this.mainGraphic.mouseMode = SJ.UI.MOUSE_MODE.TEST_AND_BLOCK;
			this.addChild(this.mainGraphic);

			this.layout = new SJ.Layout(710, 550, [], 12, 'row', CENTER);

			this.coinTexture = new SJ.SpriteSheetTexture2(
				userDataBarSS,
				0,
				0,
				null,
				null,
				0,
				0,
				56,
				60,
				0.75,
				0.75
			);
			this.layout.addChild(this.coinTexture);

			this.label = new SJ.Label(
				`${SJ.playerData.data.dailyBonus} KASY`,
				0,
				0,
				null,
				null,
				28,
				color(239, 199, 80),
				NORMAL,
				color(96, 64, 31),
				4,
				SJ.dailyBonusFont
			);
			this.layout.addChild(this.label);

			this.addChild(this.layout);

			this.closeBtn = new SJ.TextureButton(920, 445, null, null);
			this.closeBtn.onMousePress = () => this.hide();
			this.addChild(this.closeBtn);

			this.show();
		}

		show = () => {
			if (parseInt(SJ.playerData.data.dailyBonus) > 0) {
				fetch(`${SJ.APILink}user/getDailyBonus.php`, {
					method: 'POST',
					headers: { 'Content-Type': 'application/json' },
					body: JSON.stringify({
						name: SJ.playerData.data['name'],
					}),
				})
					.then(() => {
						const newMoney =
							parseInt(SJ.playerData.data['money']) +
							parseInt(SJ.playerData.data['dailyBonus']);

						SJ.playerData.data.money = newMoney;
						SJ.playerData.data.dailyBonus = 0;
						SJ.userDataBar.updateDisplayData();
						this.isVisible = true;
					})
					.catch((e) => console.log(e));
			} else this.hide();
		};
	};
});
